var _title, _path, _path2, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _path3, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _polygon25, _polygon26, _polygon27, _polygon28, _polygon29, _polygon30, _polygon31, _polygon32, _polygon33, _polygon34, _polygon35, _polygon36, _polygon37, _polygon38, _polygon39, _polygon40, _polygon41, _polygon42, _polygon43, _polygon44, _polygon45, _polygon46, _polygon47, _polygon48, _polygon49, _polygon50, _polygon51, _polygon52, _polygon53, _polygon54, _polygon55, _polygon56, _polygon57, _polygon58, _polygon59, _polygon60, _polygon61, _polygon62, _polygon63, _polygon64, _polygon65, _polygon66, _polygon67, _polygon68, _polygon69, _polygon70, _polygon71, _polygon72, _polygon73, _polygon74, _polygon75, _polygon76, _polygon77, _polygon78, _polygon79, _polygon80, _polygon81, _polygon82, _polygon83, _polygon84, _polygon85, _polygon86, _polygon87, _polygon88, _polygon89, _polygon90, _polygon91, _polygon92, _polygon93, _polygon94, _polygon95, _polygon96, _polygon97, _polygon98, _polygon99, _polygon100, _polygon101, _polygon102, _polygon103, _polygon104, _polygon105, _polygon106, _polygon107, _polygon108, _polygon109, _polygon110, _polygon111, _polygon112, _polygon113, _polygon114, _polygon115, _polygon116, _polygon117, _polygon118, _polygon119, _polygon120, _polygon121, _polygon122, _polygon123, _polygon124, _polygon125, _polygon126, _polygon127, _polygon128, _polygon129, _polygon130, _polygon131, _polygon132, _polygon133, _polygon134, _polygon135, _polygon136, _polygon137, _polygon138, _polygon139, _polygon140, _polygon141, _polygon142, _polygon143, _polygon144, _polygon145, _polygon146, _polygon147, _polygon148, _polygon149, _polygon150, _polygon151, _polygon152, _polygon153, _polygon154, _polygon155, _polygon156, _polygon157, _polygon158, _polygon159, _polygon160, _polygon161, _polygon162, _polygon163, _polygon164, _polygon165, _polygon166, _polygon167, _polygon168, _polygon169, _polygon170, _polygon171, _polygon172, _polygon173, _polygon174, _polygon175, _polygon176, _polygon177, _polygon178, _polygon179, _polygon180, _polygon181, _polygon182, _polygon183, _polygon184, _polygon185, _polygon186, _polygon187, _polygon188, _polygon189, _polygon190, _polygon191, _polygon192, _polygon193, _polygon194, _polygon195, _polygon196, _polygon197, _polygon198, _polygon199, _polygon200, _polygon201, _polygon202, _polygon203, _polygon204, _polygon205, _path4, _path5, _ellipse, _path6, _ellipse2, _path7, _path8, _path9, _path10, _path11, _polygon206, _polygon207, _polygon208, _path12, _path13, _path14, _path15, _polygon209, _polygon210, _polygon211, _polygon212, _polygon213, _path16, _circle, _path17, _circle2, _polygon214, _polygon215, _polygon216, _polygon217, _ellipse3, _path18, _path19, _path20, _path21, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _path22, _path23, _path24, _polygon218, _polygon219, _polygon220, _polygon221, _path25, _path26, _path27, _path28, _rect, _rect2, _rect3, _rect4, _polygon222, _polygon223, _polygon224, _polygon225, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _polygon226, _polygon227, _polygon228, _polygon229, _polygon230, _polygon231, _path29, _path30, _path31, _polygon232, _polygon233, _path32, _path33, _polygon234, _polygon235, _ellipse4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgDigmenthaColored = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183.2,
    height: 462.98,
    viewBox: "0 0 183.2 462.98",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "digmentha-colored")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M137.6,215.7l-6.4-13.4,10.3-.9,41.7,46.7-30.8,21.6-3.3-10.4c-1.4-.8,0,0,.4-3l3.9-3.4,11.7-4.7h-5Z",
    transform: "translate(0 -0.02)",
    fill: "#c3c3c3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130,238.7l7.2-25.7,4-12.6L87,202.8l-49.6-2.3,4.8,14.9L48,238.5l1.7.5L57,261.9s-6.3,17-5.7,17h75.9l-5.7-17,7.3-22.9Z",
    transform: "translate(0 -0.02)",
    fill: "#c3c3c3"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "87.5 239.38 89.7 223.28 104.8 256.98 87.5 239.38",
    fill: "#c3c3c3"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "94.8 247.58 74.7 256.98 88.7 221.48 84.4 247.98 94.8 247.58",
    fill: "#c3c3c3"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "129.7 330.78 135.8 304.78 127.2 278.88 51.4 278.88 42.8 304.78 49.2 330.78 68 330.78 82.6 330.78 89.6 330.78 105.1 330.78 129.7 330.78",
    fill: "#c3c3c3"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "95.7 326.28 110.6 388.58 103.1 400.08 110.6 438.38 121.6 438.38 117.7 387.68 131.2 326.28 95.7 326.28",
    fill: "#c3c3c3"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "83.9 326.28 69 388.58 76.4 400.08 69 438.38 58 438.38 61.9 387.68 48.3 326.28 83.9 326.28",
    fill: "#c3c3c3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1,454.4l-30.6,5.8s-10.9-2.3-3.1-16.5L59,435.6l10.9.5Zm38.3,0,30.6,5.8s10.9-2.3,3.1-16.5l-21.6-8.1-10.9.5ZM73.7,22.3,56.5,18s3.2-6.6,5.3-7S80.1,2.7,80.1,2.7s21.4.4,23.4,1.7,14.1,8.2,14.1,8.2v8L103.5,24l-5.9,6.1s-23.8-1.8-23.9-3.4Z",
    transform: "translate(0 -0.02)",
    fill: "#c3c3c3"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "90.2 246.58 88.9 246.38 87.5 246.38 87.5 246.58 87.5 246.68 90.2 246.68 90.2 246.58",
    fill: "#9d9d9d"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "87.5 247.58 88.9 247.58 90.2 247.38 90.2 247.28 87.5 247.28 87.5 247.38 87.5 247.58",
    fill: "#9d9d9d"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "90.2 244.78 88.9 244.48 87.5 244.48 87.5 244.78 87.5 244.88 90.2 244.88 90.2 244.78",
    fill: "#9d9d9d"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "87.5 245.78 88.9 245.78 90.2 245.58 90.2 245.38 87.5 245.38 87.5 245.58 87.5 245.78",
    fill: "#9d9d9d"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "90.2 242.98 88.9 242.68 87.5 242.68 87.5 242.98 87.5 243.08 90.2 243.08 90.2 242.98",
    fill: "#9d9d9d"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "87.5 243.08 88.9 243.08 90.2 242.78 90.2 242.68 87.5 242.68 87.5 242.78 87.5 243.08",
    fill: "#9d9d9d"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "90.2 241.08 88.9 240.88 87.5 240.88 87.5 241.08 87.5 241.28 90.2 241.28 90.2 241.08",
    fill: "#9d9d9d"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "87.5 241.28 88.9 241.28 90.2 240.98 90.2 240.88 87.5 240.88 87.5 240.98 87.5 241.28",
    fill: "#9d9d9d"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "90.2 239.28 88.9 239.08 87.5 239.08 87.5 239.28 87.5 239.38 90.2 239.38 90.2 239.28",
    fill: "#9d9d9d"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "87.5 239.38 88.9 239.38 90.2 239.18 90.2 239.08 87.5 239.08 87.5 239.18 87.5 239.38",
    fill: "#9d9d9d"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "90.2 236.58 88.9 236.28 87.5 236.28 87.5 236.58 87.5 236.68 90.2 236.68 90.2 236.58",
    fill: "#9d9d9d"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    points: "87.5 237.58 88.9 237.58 90.2 237.38 90.2 237.18 87.5 237.18 87.5 237.38 87.5 237.58",
    fill: "#9d9d9d"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    points: "90.2 234.68 88.9 234.48 87.5 234.48 87.5 234.68 87.5 234.88 90.2 234.88 90.2 234.68",
    fill: "#9d9d9d"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    points: "87.5 235.78 88.9 235.78 90.2 235.48 90.2 235.38 87.5 235.38 87.5 235.48 87.5 235.78",
    fill: "#9d9d9d"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    points: "90.2 232.88 88.9 232.68 87.5 232.68 87.5 232.88 87.5 233.08 90.2 233.08 90.2 232.88",
    fill: "#9d9d9d"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    points: "87.5 233.08 88.9 233.08 90.2 232.78 90.2 232.68 87.5 232.68 87.5 232.78 87.5 233.08",
    fill: "#9d9d9d"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    points: "90.2 231.08 88.9 230.88 87.5 230.88 87.5 231.08 87.5 231.18 90.2 231.18 90.2 231.08",
    fill: "#9d9d9d"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    points: "87.5 231.18 88.9 231.18 90.2 230.98 90.2 230.88 87.5 230.88 87.5 230.98 87.5 231.18",
    fill: "#9d9d9d"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    points: "90.2 229.28 88.9 228.98 87.5 228.98 87.5 229.28 87.5 229.38 90.2 229.38 90.2 229.28",
    fill: "#9d9d9d"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    points: "87.5 229.38 88.9 229.38 90.2 229.18 90.2 228.98 87.5 228.98 87.5 229.18 87.5 229.38",
    fill: "#9d9d9d"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    points: "90.2 226.48 88.9 226.28 87.5 226.28 87.5 226.48 87.5 226.68 90.2 226.68 90.2 226.48",
    fill: "#9d9d9d"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    points: "87.5 227.58 88.9 227.58 90.2 227.28 90.2 227.18 87.5 227.18 87.5 227.28 87.5 227.58",
    fill: "#9d9d9d"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    points: "90.2 224.68 88.9 224.48 87.5 224.48 87.5 224.68 87.5 224.88 90.2 224.88 90.2 224.68",
    fill: "#9d9d9d"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    points: "87.5 225.78 88.9 225.78 90.2 225.48 90.2 225.38 87.5 225.38 87.5 225.48 87.5 225.78",
    fill: "#9d9d9d"
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    points: "90.2 222.88 88.9 222.68 87.5 222.68 87.5 222.88 87.5 222.98 90.2 222.98 90.2 222.88",
    fill: "#9d9d9d"
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    points: "87.5 222.98 88.9 222.98 90.2 222.78 90.2 222.68 87.5 222.68 87.5 222.78 87.5 222.98",
    fill: "#9d9d9d"
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    points: "90.2 221.08 88.9 220.78 87.5 220.78 87.5 221.08 87.5 221.18 90.2 221.18 90.2 221.08",
    fill: "#9d9d9d"
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    points: "87.5 221.18 88.9 221.18 90.2 220.98 90.2 220.78 87.5 220.78 87.5 220.98 87.5 221.18",
    fill: "#9d9d9d"
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    points: "90.2 218.28 88.9 218.08 87.5 218.08 87.5 218.28 87.5 218.48 90.2 218.48 90.2 218.28",
    fill: "#9d9d9d"
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    points: "87.5 219.38 88.9 219.38 90.2 219.08 90.2 218.98 87.5 218.98 87.5 219.08 87.5 219.38",
    fill: "#9d9d9d"
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    points: "90.2 216.48 88.9 216.28 87.5 216.28 87.5 216.48 87.5 216.58 90.2 216.58 90.2 216.48",
    fill: "#9d9d9d"
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    points: "87.5 217.58 88.9 217.58 90.2 217.28 90.2 217.18 87.5 217.18 87.5 217.28 87.5 217.58",
    fill: "#9d9d9d"
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    points: "90.2 214.68 88.9 214.48 87.5 214.48 87.5 214.68 87.5 214.78 90.2 214.78 90.2 214.68",
    fill: "#9d9d9d"
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    points: "87.5 214.78 88.9 214.78 90.2 214.58 90.2 214.48 87.5 214.48 87.5 214.58 87.5 214.78",
    fill: "#9d9d9d"
  })), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    points: "90.2 212.88 88.9 212.58 87.5 212.58 87.5 212.88 87.5 212.98 90.2 212.98 90.2 212.88",
    fill: "#9d9d9d"
  })), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    points: "87.5 212.98 88.9 212.98 90.2 212.78 90.2 212.58 87.5 212.58 87.5 212.78 87.5 212.98",
    fill: "#9d9d9d"
  })), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    points: "90.2 211.08 88.9 210.78 87.5 210.78 87.5 211.08 87.5 211.18 90.2 211.18 90.2 211.08",
    fill: "#9d9d9d"
  })), _polygon43 || (_polygon43 = /*#__PURE__*/React.createElement("polygon", {
    points: "87.5 211.18 88.9 211.18 90.2 210.88 90.2 210.78 87.5 210.78 87.5 210.88 87.5 211.18",
    fill: "#9d9d9d"
  })), _polygon44 || (_polygon44 = /*#__PURE__*/React.createElement("polygon", {
    points: "90.2 208.28 88.9 208.08 87.5 208.08 87.5 208.28 87.5 208.38 90.2 208.38 90.2 208.28",
    fill: "#9d9d9d"
  })), _polygon45 || (_polygon45 = /*#__PURE__*/React.createElement("polygon", {
    points: "87.5 209.38 88.9 209.38 90.2 209.08 90.2 208.98 87.5 208.98 87.5 209.08 87.5 209.38",
    fill: "#9d9d9d"
  })), _polygon46 || (_polygon46 = /*#__PURE__*/React.createElement("polygon", {
    points: "88.4 247.48 89.7 247.28 91.1 247.28 91.1 247.48 91.1 247.58 88.4 247.58 88.4 247.48",
    fill: "#9d9d9d"
  })), _polygon47 || (_polygon47 = /*#__PURE__*/React.createElement("polygon", {
    points: "91.1 248.58 89.7 248.58 88.4 248.28 88.4 248.18 91.1 248.18 91.1 248.28 91.1 248.58",
    fill: "#9d9d9d"
  })), _polygon48 || (_polygon48 = /*#__PURE__*/React.createElement("polygon", {
    points: "88.4 245.68 89.7 245.38 91.1 245.38 91.1 245.68 91.1 245.78 88.4 245.78 88.4 245.68",
    fill: "#9d9d9d"
  })), _polygon49 || (_polygon49 = /*#__PURE__*/React.createElement("polygon", {
    points: "91.1 246.68 89.7 246.68 88.4 246.48 88.4 246.38 91.1 246.38 91.1 246.48 91.1 246.68",
    fill: "#9d9d9d"
  })), _polygon50 || (_polygon50 = /*#__PURE__*/React.createElement("polygon", {
    points: "88.4 243.88 89.7 243.58 91.1 243.58 91.1 243.88 91.1 243.98 88.4 243.98 88.4 243.88",
    fill: "#9d9d9d"
  })), _polygon51 || (_polygon51 = /*#__PURE__*/React.createElement("polygon", {
    points: "91.1 243.98 89.7 243.98 88.4 243.68 88.4 243.58 91.1 243.58 91.1 243.68 91.1 243.98",
    fill: "#9d9d9d"
  })), _polygon52 || (_polygon52 = /*#__PURE__*/React.createElement("polygon", {
    points: "88.4 241.98 89.7 241.78 91.1 241.78 91.1 241.98 91.1 242.18 88.4 242.18 88.4 241.98",
    fill: "#9d9d9d"
  })), _polygon53 || (_polygon53 = /*#__PURE__*/React.createElement("polygon", {
    points: "91.1 242.18 89.7 242.18 88.4 241.88 88.4 241.78 91.1 241.78 91.1 241.88 91.1 242.18",
    fill: "#9d9d9d"
  })), _polygon54 || (_polygon54 = /*#__PURE__*/React.createElement("polygon", {
    points: "88.4 240.18 89.7 239.98 91.1 239.98 91.1 240.18 91.1 240.28 88.4 240.28 88.4 240.18",
    fill: "#9d9d9d"
  })), _polygon55 || (_polygon55 = /*#__PURE__*/React.createElement("polygon", {
    points: "91.1 240.28 89.7 240.28 88.4 240.08 88.4 239.98 91.1 239.98 91.1 240.08 91.1 240.28",
    fill: "#9d9d9d"
  })), _polygon56 || (_polygon56 = /*#__PURE__*/React.createElement("polygon", {
    points: "90.2 254.78 88.9 254.58 87.5 254.58 87.5 254.78 87.5 254.88 90.2 254.88 90.2 254.78",
    fill: "#9d9d9d"
  })), _polygon57 || (_polygon57 = /*#__PURE__*/React.createElement("polygon", {
    points: "87.5 255.78 88.9 255.78 90.2 255.58 90.2 255.48 87.5 255.48 87.5 255.58 87.5 255.78",
    fill: "#9d9d9d"
  })), _polygon58 || (_polygon58 = /*#__PURE__*/React.createElement("polygon", {
    points: "90.2 252.98 88.9 252.68 87.5 252.68 87.5 252.98 87.5 253.08 90.2 253.08 90.2 252.98",
    fill: "#9d9d9d"
  })), _polygon59 || (_polygon59 = /*#__PURE__*/React.createElement("polygon", {
    points: "87.5 253.98 88.9 253.98 90.2 253.78 90.2 253.58 87.5 253.58 87.5 253.78 87.5 253.98",
    fill: "#9d9d9d"
  })), _polygon60 || (_polygon60 = /*#__PURE__*/React.createElement("polygon", {
    points: "90.2 251.18 88.9 250.88 87.5 250.88 87.5 251.18 87.5 251.28 90.2 251.28 90.2 251.18",
    fill: "#9d9d9d"
  })), _polygon61 || (_polygon61 = /*#__PURE__*/React.createElement("polygon", {
    points: "87.5 251.28 88.9 251.28 90.2 250.98 90.2 250.88 87.5 250.88 87.5 250.98 87.5 251.28",
    fill: "#9d9d9d"
  })), _polygon62 || (_polygon62 = /*#__PURE__*/React.createElement("polygon", {
    points: "90.2 249.28 88.9 249.08 87.5 249.08 87.5 249.28 87.5 249.48 90.2 249.48 90.2 249.28",
    fill: "#9d9d9d"
  })), _polygon63 || (_polygon63 = /*#__PURE__*/React.createElement("polygon", {
    points: "87.5 249.48 88.9 249.48 90.2 249.18 90.2 249.08 87.5 249.08 87.5 249.18 87.5 249.48",
    fill: "#9d9d9d"
  })), _polygon64 || (_polygon64 = /*#__PURE__*/React.createElement("polygon", {
    points: "90.2 246.58 88.9 246.38 87.5 246.38 87.5 246.58 87.5 246.68 90.2 246.68 90.2 246.58",
    fill: "#9d9d9d"
  })), _polygon65 || (_polygon65 = /*#__PURE__*/React.createElement("polygon", {
    points: "87.5 247.58 88.9 247.58 90.2 247.38 90.2 247.28 87.5 247.28 87.5 247.38 87.5 247.58",
    fill: "#9d9d9d"
  })), _polygon66 || (_polygon66 = /*#__PURE__*/React.createElement("polygon", {
    points: "88.4 255.68 89.7 255.48 91.1 255.48 91.1 255.68 91.1 255.78 88.4 255.78 88.4 255.68",
    fill: "#9d9d9d"
  })), _polygon67 || (_polygon67 = /*#__PURE__*/React.createElement("polygon", {
    points: "91.1 256.78 89.7 256.78 88.4 256.48 88.4 256.38 91.1 256.38 91.1 256.48 91.1 256.78",
    fill: "#9d9d9d"
  })), _polygon68 || (_polygon68 = /*#__PURE__*/React.createElement("polygon", {
    points: "88.4 253.88 89.7 253.58 91.1 253.58 91.1 253.88 91.1 253.98 88.4 253.98 88.4 253.88",
    fill: "#9d9d9d"
  })), _polygon69 || (_polygon69 = /*#__PURE__*/React.createElement("polygon", {
    points: "91.1 254.88 89.7 254.88 88.4 254.68 88.4 254.58 91.1 254.58 91.1 254.68 91.1 254.88",
    fill: "#9d9d9d"
  })), _polygon70 || (_polygon70 = /*#__PURE__*/React.createElement("polygon", {
    points: "88.4 252.08 89.7 251.78 91.1 251.78 91.1 252.08 91.1 252.18 88.4 252.18 88.4 252.08",
    fill: "#9d9d9d"
  })), _polygon71 || (_polygon71 = /*#__PURE__*/React.createElement("polygon", {
    points: "91.1 252.18 89.7 252.18 88.4 251.88 88.4 251.78 91.1 251.78 91.1 251.88 91.1 252.18",
    fill: "#9d9d9d"
  })), _polygon72 || (_polygon72 = /*#__PURE__*/React.createElement("polygon", {
    points: "88.4 250.18 89.7 249.98 91.1 249.98 91.1 250.18 91.1 250.38 88.4 250.38 88.4 250.18",
    fill: "#9d9d9d"
  })), _polygon73 || (_polygon73 = /*#__PURE__*/React.createElement("polygon", {
    points: "91.1 250.38 89.7 250.38 88.4 250.08 88.4 249.98 91.1 249.98 91.1 250.08 91.1 250.38",
    fill: "#9d9d9d"
  })), _polygon74 || (_polygon74 = /*#__PURE__*/React.createElement("polygon", {
    points: "88.4 247.48 89.7 247.28 91.1 247.28 91.1 247.48 91.1 247.58 88.4 247.58 88.4 247.48",
    fill: "#9d9d9d"
  })), _polygon75 || (_polygon75 = /*#__PURE__*/React.createElement("polygon", {
    points: "91.1 248.58 89.7 248.58 88.4 248.28 88.4 248.18 91.1 248.18 91.1 248.28 91.1 248.58",
    fill: "#9d9d9d"
  })), _polygon76 || (_polygon76 = /*#__PURE__*/React.createElement("polygon", {
    points: "88.4 237.48 89.7 237.18 91.1 237.18 91.1 237.48 91.1 237.58 88.4 237.58 88.4 237.48",
    fill: "#9d9d9d"
  })), _polygon77 || (_polygon77 = /*#__PURE__*/React.createElement("polygon", {
    points: "91.1 238.48 89.7 238.48 88.4 238.28 88.4 238.08 91.1 238.08 91.1 238.28 91.1 238.48",
    fill: "#9d9d9d"
  })), _polygon78 || (_polygon78 = /*#__PURE__*/React.createElement("polygon", {
    points: "88.4 235.68 89.7 235.38 91.1 235.38 91.1 235.68 91.1 235.78 88.4 235.78 88.4 235.68",
    fill: "#9d9d9d"
  })), _polygon79 || (_polygon79 = /*#__PURE__*/React.createElement("polygon", {
    points: "91.1 236.68 89.7 236.68 88.4 236.38 88.4 236.28 91.1 236.28 91.1 236.38 91.1 236.68",
    fill: "#9d9d9d"
  })), _polygon80 || (_polygon80 = /*#__PURE__*/React.createElement("polygon", {
    points: "88.4 233.78 89.7 233.58 91.1 233.58 91.1 233.78 91.1 233.98 88.4 233.98 88.4 233.78",
    fill: "#9d9d9d"
  })), _polygon81 || (_polygon81 = /*#__PURE__*/React.createElement("polygon", {
    points: "91.1 233.98 89.7 233.98 88.4 233.68 88.4 233.58 91.1 233.58 91.1 233.68 91.1 233.98",
    fill: "#9d9d9d"
  })), _polygon82 || (_polygon82 = /*#__PURE__*/React.createElement("polygon", {
    points: "88.4 231.98 89.7 231.78 91.1 231.78 91.1 231.98 91.1 232.08 88.4 232.08 88.4 231.98",
    fill: "#9d9d9d"
  })), _polygon83 || (_polygon83 = /*#__PURE__*/React.createElement("polygon", {
    points: "91.1 232.08 89.7 232.08 88.4 231.88 88.4 231.78 91.1 231.78 91.1 231.88 91.1 232.08",
    fill: "#9d9d9d"
  })), _polygon84 || (_polygon84 = /*#__PURE__*/React.createElement("polygon", {
    points: "88.4 230.18 89.7 229.88 91.1 229.88 91.1 230.18 91.1 230.28 88.4 230.28 88.4 230.18",
    fill: "#9d9d9d"
  })), _polygon85 || (_polygon85 = /*#__PURE__*/React.createElement("polygon", {
    points: "91.1 230.28 89.7 230.28 88.4 230.08 88.4 229.88 91.1 229.88 91.1 230.08 91.1 230.28",
    fill: "#9d9d9d"
  })), _polygon86 || (_polygon86 = /*#__PURE__*/React.createElement("polygon", {
    points: "88.4 227.48 89.7 227.18 91.1 227.18 91.1 227.48 91.1 227.58 88.4 227.58 88.4 227.48",
    fill: "#9d9d9d"
  })), _polygon87 || (_polygon87 = /*#__PURE__*/React.createElement("polygon", {
    points: "91.1 228.48 89.7 228.48 88.4 228.28 88.4 228.08 91.1 228.08 91.1 228.28 91.1 228.48",
    fill: "#9d9d9d"
  })), _polygon88 || (_polygon88 = /*#__PURE__*/React.createElement("polygon", {
    points: "88.4 225.58 89.7 225.38 91.1 225.38 91.1 225.58 91.1 225.78 88.4 225.78 88.4 225.58",
    fill: "#9d9d9d"
  })), _polygon89 || (_polygon89 = /*#__PURE__*/React.createElement("polygon", {
    points: "91.1 226.68 89.7 226.68 88.4 226.38 88.4 226.28 91.1 226.28 91.1 226.38 91.1 226.68",
    fill: "#9d9d9d"
  })), _polygon90 || (_polygon90 = /*#__PURE__*/React.createElement("polygon", {
    points: "88.4 223.78 89.7 223.58 91.1 223.58 91.1 223.78 91.1 223.88 88.4 223.88 88.4 223.78",
    fill: "#9d9d9d"
  })), _polygon91 || (_polygon91 = /*#__PURE__*/React.createElement("polygon", {
    points: "91.1 223.88 89.7 223.88 88.4 223.68 88.4 223.58 91.1 223.58 91.1 223.68 91.1 223.88",
    fill: "#9d9d9d"
  })), _polygon92 || (_polygon92 = /*#__PURE__*/React.createElement("polygon", {
    points: "88.4 221.98 89.7 221.68 91.1 221.68 91.1 221.98 91.1 222.08 88.4 222.08 88.4 221.98",
    fill: "#9d9d9d"
  })), _polygon93 || (_polygon93 = /*#__PURE__*/React.createElement("polygon", {
    points: "91.1 222.08 89.7 222.08 88.4 221.88 88.4 221.68 91.1 221.68 91.1 221.88 91.1 222.08",
    fill: "#9d9d9d"
  })), _polygon94 || (_polygon94 = /*#__PURE__*/React.createElement("polygon", {
    points: "88.4 219.28 89.7 218.98 91.1 218.98 91.1 219.28 91.1 219.38 88.4 219.38 88.4 219.28",
    fill: "#9d9d9d"
  })), _polygon95 || (_polygon95 = /*#__PURE__*/React.createElement("polygon", {
    points: "91.1 220.28 89.7 220.28 88.4 219.98 88.4 219.88 91.1 219.88 91.1 219.98 91.1 220.28",
    fill: "#9d9d9d"
  })), _polygon96 || (_polygon96 = /*#__PURE__*/React.createElement("polygon", {
    points: "88.4 217.38 89.7 217.18 91.1 217.18 91.1 217.38 91.1 217.58 88.4 217.58 88.4 217.38",
    fill: "#9d9d9d"
  })), _polygon97 || (_polygon97 = /*#__PURE__*/React.createElement("polygon", {
    points: "91.1 218.48 89.7 218.48 88.4 218.18 88.4 218.08 91.1 218.08 91.1 218.18 91.1 218.48",
    fill: "#9d9d9d"
  })), _polygon98 || (_polygon98 = /*#__PURE__*/React.createElement("polygon", {
    points: "88.4 215.58 89.7 215.38 91.1 215.38 91.1 215.58 91.1 215.68 88.4 215.68 88.4 215.58",
    fill: "#9d9d9d"
  })), _polygon99 || (_polygon99 = /*#__PURE__*/React.createElement("polygon", {
    points: "91.1 215.68 89.7 215.68 88.4 215.48 88.4 215.38 91.1 215.38 91.1 215.48 91.1 215.68",
    fill: "#9d9d9d"
  })), _polygon100 || (_polygon100 = /*#__PURE__*/React.createElement("polygon", {
    points: "88.4 213.78 89.7 213.48 91.1 213.48 91.1 213.78 91.1 213.88 88.4 213.88 88.4 213.78",
    fill: "#9d9d9d"
  })), _polygon101 || (_polygon101 = /*#__PURE__*/React.createElement("polygon", {
    points: "91.1 213.88 89.7 213.88 88.4 213.68 88.4 213.48 91.1 213.48 91.1 213.68 91.1 213.88",
    fill: "#9d9d9d"
  })), _polygon102 || (_polygon102 = /*#__PURE__*/React.createElement("polygon", {
    points: "88.4 211.98 89.7 211.68 91.1 211.68 91.1 211.98 91.1 212.08 88.4 212.08 88.4 211.98",
    fill: "#9d9d9d"
  })), _polygon103 || (_polygon103 = /*#__PURE__*/React.createElement("polygon", {
    points: "91.1 212.08 89.7 212.08 88.4 211.78 88.4 211.68 91.1 211.68 91.1 211.78 91.1 212.08",
    fill: "#9d9d9d"
  })), _polygon104 || (_polygon104 = /*#__PURE__*/React.createElement("polygon", {
    points: "88.4 209.18 89.7 208.98 91.1 208.98 91.1 209.18 91.1 209.38 88.4 209.38 88.4 209.18",
    fill: "#9d9d9d"
  })), _polygon105 || (_polygon105 = /*#__PURE__*/React.createElement("polygon", {
    points: "91.1 210.28 89.7 210.28 88.4 209.98 88.4 209.88 91.1 209.88 91.1 209.98 91.1 210.28",
    fill: "#9d9d9d"
  })), _polygon106 || (_polygon106 = /*#__PURE__*/React.createElement("polygon", {
    points: "90.2 295.78 88.9 295.58 87.5 295.58 87.5 295.78 87.5 295.88 90.2 295.88 90.2 295.78",
    fill: "#9d9d9d"
  })), _polygon107 || (_polygon107 = /*#__PURE__*/React.createElement("polygon", {
    points: "87.5 295.88 88.9 295.88 90.2 295.68 90.2 295.58 87.5 295.58 87.5 295.68 87.5 295.88",
    fill: "#9d9d9d"
  })), _polygon108 || (_polygon108 = /*#__PURE__*/React.createElement("polygon", {
    points: "90.2 293.98 88.9 293.68 87.5 293.68 87.5 293.98 87.5 294.08 90.2 294.08 90.2 293.98",
    fill: "#9d9d9d"
  })), _polygon109 || (_polygon109 = /*#__PURE__*/React.createElement("polygon", {
    points: "87.5 294.08 88.9 294.08 90.2 293.88 90.2 293.68 87.5 293.68 87.5 293.88 87.5 294.08",
    fill: "#9d9d9d"
  })), _polygon110 || (_polygon110 = /*#__PURE__*/React.createElement("polygon", {
    points: "90.2 291.28 88.9 290.98 87.5 290.98 87.5 291.28 87.5 291.38 90.2 291.38 90.2 291.28",
    fill: "#9d9d9d"
  })), _polygon111 || (_polygon111 = /*#__PURE__*/React.createElement("polygon", {
    points: "87.5 292.28 88.9 292.28 90.2 292.08 90.2 291.88 87.5 291.88 87.5 292.08 87.5 292.28",
    fill: "#9d9d9d"
  })), _polygon112 || (_polygon112 = /*#__PURE__*/React.createElement("polygon", {
    points: "90.2 289.38 88.9 289.18 87.5 289.18 87.5 289.38 87.5 289.58 90.2 289.58 90.2 289.38",
    fill: "#9d9d9d"
  })), _polygon113 || (_polygon113 = /*#__PURE__*/React.createElement("polygon", {
    points: "87.5 290.48 88.9 290.48 90.2 290.18 90.2 290.08 87.5 290.08 87.5 290.18 87.5 290.48",
    fill: "#9d9d9d"
  })), _polygon114 || (_polygon114 = /*#__PURE__*/React.createElement("polygon", {
    points: "90.2 287.58 88.9 287.38 87.5 287.38 87.5 287.58 87.5 287.68 90.2 287.68 90.2 287.58",
    fill: "#9d9d9d"
  })), _polygon115 || (_polygon115 = /*#__PURE__*/React.createElement("polygon", {
    points: "87.5 287.68 88.9 287.68 90.2 287.48 90.2 287.38 87.5 287.38 87.5 287.48 87.5 287.68",
    fill: "#9d9d9d"
  })), _polygon116 || (_polygon116 = /*#__PURE__*/React.createElement("polygon", {
    points: "90.2 285.78 88.9 285.48 87.5 285.48 87.5 285.78 87.5 285.88 90.2 285.88 90.2 285.78",
    fill: "#9d9d9d"
  })), _polygon117 || (_polygon117 = /*#__PURE__*/React.createElement("polygon", {
    points: "87.5 285.88 88.9 285.88 90.2 285.68 90.2 285.48 87.5 285.48 87.5 285.68 87.5 285.88",
    fill: "#9d9d9d"
  })), _polygon118 || (_polygon118 = /*#__PURE__*/React.createElement("polygon", {
    points: "90.2 283.98 88.9 283.68 87.5 283.68 87.5 283.98 87.5 284.08 90.2 284.08 90.2 283.98",
    fill: "#9d9d9d"
  })), _polygon119 || (_polygon119 = /*#__PURE__*/React.createElement("polygon", {
    points: "87.5 284.08 88.9 284.08 90.2 283.78 90.2 283.68 87.5 283.68 87.5 283.78 87.5 284.08",
    fill: "#9d9d9d"
  })), _polygon120 || (_polygon120 = /*#__PURE__*/React.createElement("polygon", {
    points: "90.2 281.18 88.9 280.98 87.5 280.98 87.5 281.18 87.5 281.38 90.2 281.38 90.2 281.18",
    fill: "#9d9d9d"
  })), _polygon121 || (_polygon121 = /*#__PURE__*/React.createElement("polygon", {
    points: "87.5 282.28 88.9 282.28 90.2 281.98 90.2 281.88 87.5 281.88 87.5 281.98 87.5 282.28",
    fill: "#9d9d9d"
  })), _polygon122 || (_polygon122 = /*#__PURE__*/React.createElement("polygon", {
    points: "90.2 279.38 88.9 279.18 87.5 279.18 87.5 279.38 87.5 279.48 90.2 279.48 90.2 279.38",
    fill: "#9d9d9d"
  })), _polygon123 || (_polygon123 = /*#__PURE__*/React.createElement("polygon", {
    points: "87.5 280.38 88.9 280.38 90.2 280.18 90.2 280.08 87.5 280.08 87.5 280.18 87.5 280.38",
    fill: "#9d9d9d"
  })), _polygon124 || (_polygon124 = /*#__PURE__*/React.createElement("polygon", {
    points: "90.2 277.58 88.9 277.28 87.5 277.28 87.5 277.58 87.5 277.68 90.2 277.68 90.2 277.58",
    fill: "#9d9d9d"
  })), _polygon125 || (_polygon125 = /*#__PURE__*/React.createElement("polygon", {
    points: "87.5 277.68 88.9 277.68 90.2 277.48 90.2 277.28 87.5 277.28 87.5 277.48 87.5 277.68",
    fill: "#9d9d9d"
  })), _polygon126 || (_polygon126 = /*#__PURE__*/React.createElement("polygon", {
    points: "90.2 275.78 88.9 275.48 87.5 275.48 87.5 275.78 87.5 275.88 90.2 275.88 90.2 275.78",
    fill: "#9d9d9d"
  })), _polygon127 || (_polygon127 = /*#__PURE__*/React.createElement("polygon", {
    points: "87.5 275.88 88.9 275.88 90.2 275.58 90.2 275.48 87.5 275.48 87.5 275.58 87.5 275.88",
    fill: "#9d9d9d"
  })), _polygon128 || (_polygon128 = /*#__PURE__*/React.createElement("polygon", {
    points: "90.2 273.88 88.9 273.68 87.5 273.68 87.5 273.88 87.5 274.08 90.2 274.08 90.2 273.88",
    fill: "#9d9d9d"
  })), _polygon129 || (_polygon129 = /*#__PURE__*/React.createElement("polygon", {
    points: "87.5 274.08 88.9 274.08 90.2 273.78 90.2 273.68 87.5 273.68 87.5 273.78 87.5 274.08",
    fill: "#9d9d9d"
  })), _polygon130 || (_polygon130 = /*#__PURE__*/React.createElement("polygon", {
    points: "90.2 271.18 88.9 270.98 87.5 270.98 87.5 271.18 87.5 271.28 90.2 271.28 90.2 271.18",
    fill: "#9d9d9d"
  })), _polygon131 || (_polygon131 = /*#__PURE__*/React.createElement("polygon", {
    points: "87.5 272.18 88.9 272.18 90.2 271.98 90.2 271.88 87.5 271.88 87.5 271.98 87.5 272.18",
    fill: "#9d9d9d"
  })), _polygon132 || (_polygon132 = /*#__PURE__*/React.createElement("polygon", {
    points: "90.2 269.38 88.9 269.08 87.5 269.08 87.5 269.38 87.5 269.48 90.2 269.48 90.2 269.38",
    fill: "#9d9d9d"
  })), _polygon133 || (_polygon133 = /*#__PURE__*/React.createElement("polygon", {
    points: "87.5 270.38 88.9 270.38 90.2 270.18 90.2 269.98 87.5 269.98 87.5 270.18 87.5 270.38",
    fill: "#9d9d9d"
  })), _polygon134 || (_polygon134 = /*#__PURE__*/React.createElement("polygon", {
    points: "90.2 267.58 88.9 267.28 87.5 267.28 87.5 267.58 87.5 267.68 90.2 267.68 90.2 267.58",
    fill: "#9d9d9d"
  })), _polygon135 || (_polygon135 = /*#__PURE__*/React.createElement("polygon", {
    points: "87.5 267.68 88.9 267.68 90.2 267.38 90.2 267.28 87.5 267.28 87.5 267.38 87.5 267.68",
    fill: "#9d9d9d"
  })), _polygon136 || (_polygon136 = /*#__PURE__*/React.createElement("polygon", {
    points: "90.2 265.68 88.9 265.48 87.5 265.48 87.5 265.68 87.5 265.88 90.2 265.88 90.2 265.68",
    fill: "#9d9d9d"
  })), _polygon137 || (_polygon137 = /*#__PURE__*/React.createElement("polygon", {
    points: "87.5 265.88 88.9 265.88 90.2 265.58 90.2 265.48 87.5 265.48 87.5 265.58 87.5 265.88",
    fill: "#9d9d9d"
  })), _polygon138 || (_polygon138 = /*#__PURE__*/React.createElement("polygon", {
    points: "90.2 262.98 88.9 262.78 87.5 262.78 87.5 262.98 87.5 263.08 90.2 263.08 90.2 262.98",
    fill: "#9d9d9d"
  })), _polygon139 || (_polygon139 = /*#__PURE__*/React.createElement("polygon", {
    points: "87.5 263.98 88.9 263.98 90.2 263.78 90.2 263.68 87.5 263.68 87.5 263.78 87.5 263.98",
    fill: "#9d9d9d"
  })), _polygon140 || (_polygon140 = /*#__PURE__*/React.createElement("polygon", {
    points: "90.2 261.18 88.9 260.88 87.5 260.88 87.5 261.18 87.5 261.28 90.2 261.28 90.2 261.18",
    fill: "#9d9d9d"
  })), _polygon141 || (_polygon141 = /*#__PURE__*/React.createElement("polygon", {
    points: "87.5 262.18 88.9 262.18 90.2 261.98 90.2 261.78 87.5 261.78 87.5 261.98 87.5 262.18",
    fill: "#9d9d9d"
  })), _polygon142 || (_polygon142 = /*#__PURE__*/React.createElement("polygon", {
    points: "90.2 259.38 88.9 259.08 87.5 259.08 87.5 259.38 87.5 259.48 90.2 259.48 90.2 259.38",
    fill: "#9d9d9d"
  })), _polygon143 || (_polygon143 = /*#__PURE__*/React.createElement("polygon", {
    points: "87.5 259.48 88.9 259.48 90.2 259.18 90.2 259.08 87.5 259.08 87.5 259.18 87.5 259.48",
    fill: "#9d9d9d"
  })), _polygon144 || (_polygon144 = /*#__PURE__*/React.createElement("polygon", {
    points: "90.2 257.48 88.9 257.28 87.5 257.28 87.5 257.48 87.5 257.68 90.2 257.68 90.2 257.48",
    fill: "#9d9d9d"
  })), _polygon145 || (_polygon145 = /*#__PURE__*/React.createElement("polygon", {
    points: "87.5 257.68 88.9 257.68 90.2 257.38 90.2 257.28 87.5 257.28 87.5 257.38 87.5 257.68",
    fill: "#9d9d9d"
  })), _polygon146 || (_polygon146 = /*#__PURE__*/React.createElement("polygon", {
    points: "88.4 296.68 89.7 296.48 91.1 296.48 91.1 296.68 91.1 296.88 88.4 296.88 88.4 296.68",
    fill: "#9d9d9d"
  })), _polygon147 || (_polygon147 = /*#__PURE__*/React.createElement("polygon", {
    points: "91.1 296.88 89.7 296.88 88.4 296.58 88.4 296.48 91.1 296.48 91.1 296.58 91.1 296.88",
    fill: "#9d9d9d"
  })), _polygon148 || (_polygon148 = /*#__PURE__*/React.createElement("polygon", {
    points: "88.4 294.88 89.7 294.68 91.1 294.68 91.1 294.88 91.1 294.98 88.4 294.98 88.4 294.88",
    fill: "#9d9d9d"
  })), _polygon149 || (_polygon149 = /*#__PURE__*/React.createElement("polygon", {
    points: "91.1 294.98 89.7 294.98 88.4 294.78 88.4 294.68 91.1 294.68 91.1 294.78 91.1 294.98",
    fill: "#9d9d9d"
  })), _polygon150 || (_polygon150 = /*#__PURE__*/React.createElement("polygon", {
    points: "88.4 292.18 89.7 291.88 91.1 291.88 91.1 292.18 91.1 292.28 88.4 292.28 88.4 292.18",
    fill: "#9d9d9d"
  })), _polygon151 || (_polygon151 = /*#__PURE__*/React.createElement("polygon", {
    points: "91.1 293.18 89.7 293.18 88.4 292.98 88.4 292.78 91.1 292.78 91.1 292.98 91.1 293.18",
    fill: "#9d9d9d"
  })), _polygon152 || (_polygon152 = /*#__PURE__*/React.createElement("polygon", {
    points: "88.4 290.28 89.7 290.08 91.1 290.08 91.1 290.28 91.1 290.48 88.4 290.48 88.4 290.28",
    fill: "#9d9d9d"
  })), _polygon153 || (_polygon153 = /*#__PURE__*/React.createElement("polygon", {
    points: "91.1 291.38 89.7 291.38 88.4 291.08 88.4 290.98 91.1 290.98 91.1 291.08 91.1 291.38",
    fill: "#9d9d9d"
  })), _polygon154 || (_polygon154 = /*#__PURE__*/React.createElement("polygon", {
    points: "88.4 288.48 89.7 288.28 91.1 288.28 91.1 288.48 91.1 288.68 88.4 288.68 88.4 288.48",
    fill: "#9d9d9d"
  })), _polygon155 || (_polygon155 = /*#__PURE__*/React.createElement("polygon", {
    points: "91.1 288.68 89.7 288.68 88.4 288.38 88.4 288.28 91.1 288.28 91.1 288.38 91.1 288.68",
    fill: "#9d9d9d"
  })), _polygon156 || (_polygon156 = /*#__PURE__*/React.createElement("polygon", {
    points: "90.2 303.98 88.9 303.78 87.5 303.78 87.5 303.98 87.5 304.08 90.2 304.08 90.2 303.98",
    fill: "#9d9d9d"
  })), _polygon157 || (_polygon157 = /*#__PURE__*/React.createElement("polygon", {
    points: "87.5 304.08 88.9 304.08 90.2 303.88 90.2 303.78 87.5 303.78 87.5 303.88 87.5 304.08",
    fill: "#9d9d9d"
  })), _polygon158 || (_polygon158 = /*#__PURE__*/React.createElement("polygon", {
    points: "90.2 302.18 88.9 301.88 87.5 301.88 87.5 302.18 87.5 302.28 90.2 302.28 90.2 302.18",
    fill: "#9d9d9d"
  })), _polygon159 || (_polygon159 = /*#__PURE__*/React.createElement("polygon", {
    points: "87.5 302.28 88.9 302.28 90.2 302.08 90.2 301.88 87.5 301.88 87.5 302.08 87.5 302.28",
    fill: "#9d9d9d"
  })), _polygon160 || (_polygon160 = /*#__PURE__*/React.createElement("polygon", {
    points: "90.2 299.48 88.9 299.18 87.5 299.18 87.5 299.48 87.5 299.58 90.2 299.58 90.2 299.48",
    fill: "#9d9d9d"
  })), _polygon161 || (_polygon161 = /*#__PURE__*/React.createElement("polygon", {
    points: "87.5 300.48 88.9 300.48 90.2 300.28 90.2 300.08 87.5 300.08 87.5 300.28 87.5 300.48",
    fill: "#9d9d9d"
  })), _polygon162 || (_polygon162 = /*#__PURE__*/React.createElement("polygon", {
    points: "90.2 297.58 88.9 297.38 87.5 297.38 87.5 297.58 87.5 297.78 90.2 297.78 90.2 297.58",
    fill: "#9d9d9d"
  })), _polygon163 || (_polygon163 = /*#__PURE__*/React.createElement("polygon", {
    points: "87.5 298.68 88.9 298.68 90.2 298.38 90.2 298.28 87.5 298.28 87.5 298.38 87.5 298.68",
    fill: "#9d9d9d"
  })), _polygon164 || (_polygon164 = /*#__PURE__*/React.createElement("polygon", {
    points: "90.2 295.78 88.9 295.58 87.5 295.58 87.5 295.78 87.5 295.88 90.2 295.88 90.2 295.78",
    fill: "#9d9d9d"
  })), _polygon165 || (_polygon165 = /*#__PURE__*/React.createElement("polygon", {
    points: "87.5 295.88 88.9 295.88 90.2 295.68 90.2 295.58 87.5 295.58 87.5 295.68 87.5 295.88",
    fill: "#9d9d9d"
  })), _polygon166 || (_polygon166 = /*#__PURE__*/React.createElement("polygon", {
    points: "88.4 304.88 89.7 304.68 91.1 304.68 91.1 304.88 91.1 305.08 88.4 305.08 88.4 304.88",
    fill: "#9d9d9d"
  })), _polygon167 || (_polygon167 = /*#__PURE__*/React.createElement("polygon", {
    points: "91.1 305.08 89.7 305.08 88.4 304.78 88.4 304.68 91.1 304.68 91.1 304.78 91.1 305.08",
    fill: "#9d9d9d"
  })), _polygon168 || (_polygon168 = /*#__PURE__*/React.createElement("polygon", {
    points: "88.4 303.08 89.7 302.88 91.1 302.88 91.1 303.08 91.1 303.18 88.4 303.18 88.4 303.08",
    fill: "#9d9d9d"
  })), _polygon169 || (_polygon169 = /*#__PURE__*/React.createElement("polygon", {
    points: "91.1 303.18 89.7 303.18 88.4 302.98 88.4 302.88 91.1 302.88 91.1 302.98 91.1 303.18",
    fill: "#9d9d9d"
  })), _polygon170 || (_polygon170 = /*#__PURE__*/React.createElement("polygon", {
    points: "88.4 300.38 89.7 300.08 91.1 300.08 91.1 300.38 91.1 300.48 88.4 300.48 88.4 300.38",
    fill: "#9d9d9d"
  })), _polygon171 || (_polygon171 = /*#__PURE__*/React.createElement("polygon", {
    points: "91.1 301.38 89.7 301.38 88.4 301.18 88.4 300.98 91.1 300.98 91.1 301.18 91.1 301.38",
    fill: "#9d9d9d"
  })), _polygon172 || (_polygon172 = /*#__PURE__*/React.createElement("polygon", {
    points: "88.4 298.48 89.7 298.28 91.1 298.28 91.1 298.48 91.1 298.68 88.4 298.68 88.4 298.48",
    fill: "#9d9d9d"
  })), _polygon173 || (_polygon173 = /*#__PURE__*/React.createElement("polygon", {
    points: "91.1 299.58 89.7 299.58 88.4 299.28 88.4 299.18 91.1 299.18 91.1 299.28 91.1 299.58",
    fill: "#9d9d9d"
  })), _polygon174 || (_polygon174 = /*#__PURE__*/React.createElement("polygon", {
    points: "88.4 296.68 89.7 296.48 91.1 296.48 91.1 296.68 91.1 296.88 88.4 296.88 88.4 296.68",
    fill: "#9d9d9d"
  })), _polygon175 || (_polygon175 = /*#__PURE__*/React.createElement("polygon", {
    points: "91.1 296.88 89.7 296.88 88.4 296.58 88.4 296.48 91.1 296.48 91.1 296.58 91.1 296.88",
    fill: "#9d9d9d"
  })), _polygon176 || (_polygon176 = /*#__PURE__*/React.createElement("polygon", {
    points: "88.4 286.68 89.7 286.48 91.1 286.48 91.1 286.68 91.1 286.78 88.4 286.78 88.4 286.68",
    fill: "#9d9d9d"
  })), _polygon177 || (_polygon177 = /*#__PURE__*/React.createElement("polygon", {
    points: "91.1 286.78 89.7 286.78 88.4 286.58 88.4 286.48 91.1 286.48 91.1 286.58 91.1 286.78",
    fill: "#9d9d9d"
  })), _polygon178 || (_polygon178 = /*#__PURE__*/React.createElement("polygon", {
    points: "88.4 284.88 89.7 284.58 91.1 284.58 91.1 284.88 91.1 284.98 88.4 284.98 88.4 284.88",
    fill: "#9d9d9d"
  })), _polygon179 || (_polygon179 = /*#__PURE__*/React.createElement("polygon", {
    points: "91.1 284.98 89.7 284.98 88.4 284.78 88.4 284.58 91.1 284.58 91.1 284.78 91.1 284.98",
    fill: "#9d9d9d"
  })), _polygon180 || (_polygon180 = /*#__PURE__*/React.createElement("polygon", {
    points: "88.4 282.08 89.7 281.88 91.1 281.88 91.1 282.08 91.1 282.28 88.4 282.28 88.4 282.08",
    fill: "#9d9d9d"
  })), _polygon181 || (_polygon181 = /*#__PURE__*/React.createElement("polygon", {
    points: "91.1 283.18 89.7 283.18 88.4 282.88 88.4 282.78 91.1 282.78 91.1 282.88 91.1 283.18",
    fill: "#9d9d9d"
  })), _polygon182 || (_polygon182 = /*#__PURE__*/React.createElement("polygon", {
    points: "88.4 280.28 89.7 280.08 91.1 280.08 91.1 280.28 91.1 280.38 88.4 280.38 88.4 280.28",
    fill: "#9d9d9d"
  })), _polygon183 || (_polygon183 = /*#__PURE__*/React.createElement("polygon", {
    points: "91.1 281.38 89.7 281.38 88.4 281.08 88.4 280.98 91.1 280.98 91.1 281.08 91.1 281.38",
    fill: "#9d9d9d"
  })), _polygon184 || (_polygon184 = /*#__PURE__*/React.createElement("polygon", {
    points: "88.4 278.48 89.7 278.28 91.1 278.28 91.1 278.48 91.1 278.58 88.4 278.58 88.4 278.48",
    fill: "#9d9d9d"
  })), _polygon185 || (_polygon185 = /*#__PURE__*/React.createElement("polygon", {
    points: "91.1 278.58 89.7 278.58 88.4 278.38 88.4 278.28 91.1 278.28 91.1 278.38 91.1 278.58",
    fill: "#9d9d9d"
  })), _polygon186 || (_polygon186 = /*#__PURE__*/React.createElement("polygon", {
    points: "88.4 276.68 89.7 276.38 91.1 276.38 91.1 276.68 91.1 276.78 88.4 276.78 88.4 276.68",
    fill: "#9d9d9d"
  })), _polygon187 || (_polygon187 = /*#__PURE__*/React.createElement("polygon", {
    points: "91.1 276.78 89.7 276.78 88.4 276.58 88.4 276.38 91.1 276.38 91.1 276.58 91.1 276.78",
    fill: "#9d9d9d"
  })), _polygon188 || (_polygon188 = /*#__PURE__*/React.createElement("polygon", {
    points: "88.4 274.88 89.7 274.58 91.1 274.58 91.1 274.88 91.1 274.98 88.4 274.98 88.4 274.88",
    fill: "#9d9d9d"
  })), _polygon189 || (_polygon189 = /*#__PURE__*/React.createElement("polygon", {
    points: "91.1 274.98 89.7 274.98 88.4 274.68 88.4 274.58 91.1 274.58 91.1 274.68 91.1 274.98",
    fill: "#9d9d9d"
  })), _polygon190 || (_polygon190 = /*#__PURE__*/React.createElement("polygon", {
    points: "88.4 272.08 89.7 271.88 91.1 271.88 91.1 272.08 91.1 272.18 88.4 272.18 88.4 272.08",
    fill: "#9d9d9d"
  })), _polygon191 || (_polygon191 = /*#__PURE__*/React.createElement("polygon", {
    points: "91.1 273.18 89.7 273.18 88.4 272.88 88.4 272.78 91.1 272.78 91.1 272.88 91.1 273.18",
    fill: "#9d9d9d"
  })), _polygon192 || (_polygon192 = /*#__PURE__*/React.createElement("polygon", {
    points: "88.4 270.28 89.7 269.98 91.1 269.98 91.1 270.28 91.1 270.38 88.4 270.38 88.4 270.28",
    fill: "#9d9d9d"
  })), _polygon193 || (_polygon193 = /*#__PURE__*/React.createElement("polygon", {
    points: "91.1 271.28 89.7 271.28 88.4 271.08 88.4 270.98 91.1 270.98 91.1 271.08 91.1 271.28",
    fill: "#9d9d9d"
  })), _polygon194 || (_polygon194 = /*#__PURE__*/React.createElement("polygon", {
    points: "88.4 268.48 89.7 268.18 91.1 268.18 91.1 268.48 91.1 268.58 88.4 268.58 88.4 268.48",
    fill: "#9d9d9d"
  })), _polygon195 || (_polygon195 = /*#__PURE__*/React.createElement("polygon", {
    points: "91.1 268.58 89.7 268.58 88.4 268.38 88.4 268.18 91.1 268.18 91.1 268.38 91.1 268.58",
    fill: "#9d9d9d"
  })), _polygon196 || (_polygon196 = /*#__PURE__*/React.createElement("polygon", {
    points: "88.4 266.58 89.7 266.38 91.1 266.38 91.1 266.58 91.1 266.78 88.4 266.78 88.4 266.58",
    fill: "#9d9d9d"
  })), _polygon197 || (_polygon197 = /*#__PURE__*/React.createElement("polygon", {
    points: "91.1 266.78 89.7 266.78 88.4 266.48 88.4 266.38 91.1 266.38 91.1 266.48 91.1 266.78",
    fill: "#9d9d9d"
  })), _polygon198 || (_polygon198 = /*#__PURE__*/React.createElement("polygon", {
    points: "88.4 263.88 89.7 263.68 91.1 263.68 91.1 263.88 91.1 263.98 88.4 263.98 88.4 263.88",
    fill: "#9d9d9d"
  })), _polygon199 || (_polygon199 = /*#__PURE__*/React.createElement("polygon", {
    points: "91.1 264.98 89.7 264.98 88.4 264.68 88.4 264.58 91.1 264.58 91.1 264.68 91.1 264.98",
    fill: "#9d9d9d"
  })), _polygon200 || (_polygon200 = /*#__PURE__*/React.createElement("polygon", {
    points: "88.4 262.08 89.7 261.78 91.1 261.78 91.1 262.08 91.1 262.18 88.4 262.18 88.4 262.08",
    fill: "#9d9d9d"
  })), _polygon201 || (_polygon201 = /*#__PURE__*/React.createElement("polygon", {
    points: "91.1 263.08 89.7 263.08 88.4 262.88 88.4 262.78 91.1 262.78 91.1 262.88 91.1 263.08",
    fill: "#9d9d9d"
  })), _polygon202 || (_polygon202 = /*#__PURE__*/React.createElement("polygon", {
    points: "88.4 260.28 89.7 259.98 91.1 259.98 91.1 260.28 91.1 260.38 88.4 260.38 88.4 260.28",
    fill: "#9d9d9d"
  })), _polygon203 || (_polygon203 = /*#__PURE__*/React.createElement("polygon", {
    points: "91.1 260.38 89.7 260.38 88.4 260.18 88.4 259.98 91.1 259.98 91.1 260.18 91.1 260.38",
    fill: "#9d9d9d"
  })), _polygon204 || (_polygon204 = /*#__PURE__*/React.createElement("polygon", {
    points: "88.4 258.38 89.7 258.18 91.1 258.18 91.1 258.38 91.1 258.58 88.4 258.58 88.4 258.38",
    fill: "#9d9d9d"
  })), _polygon205 || (_polygon205 = /*#__PURE__*/React.createElement("polygon", {
    points: "91.1 258.58 89.7 258.58 88.4 258.28 88.4 258.18 91.1 258.18 91.1 258.28 91.1 258.58",
    fill: "#9d9d9d"
  })), /*#__PURE__*/React.createElement("image", {
    width: 160,
    height: 207,
    transform: "translate(13.77 24.51) scale(0.94 0.94)",
    opacity: 0.15,
    xlinkHref: "data:image/png;base64,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",
    style: {
      isolation: "isolate"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3,26.4c-36.4,0-66.1,25.8-69,58.5h0v.5h-.2v.1l5.4,65.8c.8,9.4,1.2,14.1,7.1,21.9,10.7,14.3,28.9,24.6,44.2,32.8a30.34,30.34,0,0,0,26.3-.9c3.2-1.1,9.2-5.2,11.9-6.8,3.6-2,6.8-5.2,10.1-7.6,7-5,4.5-4.1,13.9-12.1,11.7-10,15.5-25.9,16.4-39.9l1.5-24.3c.6-9.7,1.8-19.5,1.8-29.2v-.6C155.7,52.2,125.7,26.4,89.3,26.4Z",
    transform: "translate(0 -0.02)",
    fill: "#eeab89"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4,106.6a12.64,12.64,0,0,0-11.8,12.5v21.4A12.65,12.65,0,0,0,26.4,153V106.6Zm126.7,0a12.64,12.64,0,0,1,11.8,12.5v21.4A12.65,12.65,0,0,1,153.1,153V106.6Z",
    transform: "translate(0 -0.02)",
    fill: "#eeab89"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.9,
    cy: 123.48,
    rx: 3.6,
    ry: 5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4,238.7l1.8.5,7.4,23s-6.3,17.1-5.7,17.1l-8.7,25.8,6.4,26,4.6,20.7.9-4.1-1.7-16.5-6.4-26,9.7-26c-.6,0,5.7-17,5.7-17l-7.4-23-1.8-.5-5.8-23.2-4.7-14.8-4.9-.2,4.8,15Z",
    transform: "translate(0 -0.02)",
    fill: "#d7d7d7"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.5,
    cy: 123.48,
    rx: 3.6,
    ry: 5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4,172.4c-.6.2-2.3.9-3,1.2-.8-.3-2.4-1-3-1.2-3.9-1.2-12.5,4.5-12.5,4.5v.3c10.6,1.1,14.3-.2,15.5-1.6,1.2,1.3,4.9,2.7,15.5,1.6V177C104.8,177,96.2,171.2,92.4,172.4Z",
    transform: "translate(0 -0.02)",
    fill: "#ac7560"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8,176.5s14.1,13.1,31,0l-15.5-3.3Z",
    transform: "translate(0 -0.02)",
    fill: "#ac7560"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "39.8 111.18 31 133.88 36.9 134.88 47.4 111.18 39.8 111.18",
    fill: "#f3d0c0",
    opacity: 0.49,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "48.8 111.18 40.1 133.88 42.5 134.88 52.9 111.18 48.8 111.18",
    fill: "#f3d0c0",
    opacity: 0.49,
    style: {
      isolation: "isolate"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9,135.8H34.2a7.81,7.81,0,0,1-7.8-7.8V118a7.81,7.81,0,0,1,7.8-7.8H76.9a7.81,7.81,0,0,1,7.8,7.8v10a7.75,7.75,0,0,1-7.8,7.8ZM34.2,112a6.06,6.06,0,0,0-6.1,6.1v10a6.12,6.12,0,0,0,6.1,6.1H76.9a6.06,6.06,0,0,0,6.1-6.1v-10a6.12,6.12,0,0,0-6.1-6.1H34.2Zm110.2,23.8H101.7a7.81,7.81,0,0,1-7.8-7.8V118a7.81,7.81,0,0,1,7.8-7.8h42.7a7.81,7.81,0,0,1,7.8,7.8v10a7.81,7.81,0,0,1-7.8,7.8ZM101.7,112a6.06,6.06,0,0,0-6.1,6.1v10a6.12,6.12,0,0,0,6.1,6.1h42.7a6.06,6.06,0,0,0,6.1-6.1v-10a6.12,6.12,0,0,0-6.1-6.1H101.7Z",
    transform: "translate(0 -0.02)",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6,128.5a6.88,6.88,0,0,0-9.6,0l-1.2-1.2c.1-.1,5.7-5.5,11.8,0Z",
    transform: "translate(0 -0.02)",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8,107.3S38,24.8,88.1,46.1c0,0,48.1-21.9,69.5,61.5l2.8-22.1s-5.9-68.8-71-58.7c0,0-62.1-19.2-69.4,58.8Z",
    transform: "translate(0 -0.02)",
    fill: "#c3c3c3"
  })), _polygon206 || (_polygon206 = /*#__PURE__*/React.createElement("polygon", {
    points: "73.8 24.58 87.8 26.38 102.1 25.68 88 24.58 73.8 24.58",
    fill: "#cf262a"
  })), _polygon207 || (_polygon207 = /*#__PURE__*/React.createElement("polygon", {
    points: "152.3 131.18 157.7 107.48 148.6 111.08 151.8 115.18 152.3 131.18",
    fill: "#fff"
  })), _polygon208 || (_polygon208 = /*#__PURE__*/React.createElement("polygon", {
    points: "27.3 131.18 21.9 107.48 31 111.08 27.8 115.18 27.3 131.18",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M154.8,87.5s14.4,59.8,7.3,72.9c0,0,.8-46-10.8-72.9h3.5Zm-131,0s-14.4,59.8-7.3,72.9c0,0-.8-46,10.8-72.9H23.8Z",
    transform: "translate(0 -0.02)",
    fill: "#c3c3c3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M104.8,165.9s8.1,9.3,4.6,19.1M73.8,165.9s-8.1,9.3-4.6,19.1m34.7-48.3a29.08,29.08,0,0,0,28.3,0m-83.9,0a29.08,29.08,0,0,0,28.3,0",
    transform: "translate(0 -0.02)",
    fill: "none",
    stroke: "#b67862",
    strokeWidth: 0.3
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3,45.9s15.9-3.7,16.1,17C105.4,62.9,109.4,39.1,89.3,45.9Zm14.6-25.8s6.9-14.3,22.8-1.9C126.6,18.1,110.9.7,103.9,20.1Z",
    transform: "translate(0 -0.02)",
    fill: "#c3c3c3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M103.9,18.2s6.9-14.3,22.8-1.9C126.6,16.3,110.9-1.1,103.9,18.2ZM74.7,23.7S67.8,9.4,51.9,21.8C52,21.7,67.7,4.4,74.7,23.7Zm5.5,18.5S63.2,46,66,66.5C66,66.5,62,38.7,80.2,42.2Zm7.2-26.7S84.8-.5,104.8.7C104.8.7,82.1-4.8,87.4,15.5Z",
    transform: "translate(0 -0.02)",
    fill: "#c3c3c3"
  })), _polygon209 || (_polygon209 = /*#__PURE__*/React.createElement("polygon", {
    points: "51.2 243.48 68.2 245.18 79.3 235.08 67.9 243.78 47.4 238.18 48 242.78 51.2 243.48",
    fill: "#a29f9f"
  })), _polygon210 || (_polygon210 = /*#__PURE__*/React.createElement("polygon", {
    points: "48.1 242.88 41.9 214.18 50.1 243.28 48.1 242.88",
    fill: "#a29f9f"
  })), _polygon211 || (_polygon211 = /*#__PURE__*/React.createElement("polygon", {
    points: "128.3 243.48 111.3 245.18 100.3 235.08 111.6 243.78 132.2 238.18 131.5 242.78 128.3 243.48",
    fill: "#a29f9f"
  })), _polygon212 || (_polygon212 = /*#__PURE__*/React.createElement("polygon", {
    points: "131.5 242.88 137.6 214.18 129.4 243.28 131.5 242.88",
    fill: "#a29f9f"
  })), _polygon213 || (_polygon213 = /*#__PURE__*/React.createElement("polygon", {
    points: "42.8 213.78 38.4 200.48 16.9 221.88 0 246.98 34 289.78 37.7 282.78 19.5 247.68 10.7 247.38 25.8 239.98 42.8 213.78",
    fill: "#c3c3c3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M131.2,62.5s12.1-5.8,4.5-53.4c0,0,12.6,34.9,2.5,54.7Z",
    transform: "translate(0 -0.02)",
    fill: "#eeab89"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 135.3,
    cy: 8.68,
    r: 4.1,
    fill: "#eeab89"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6,64.3s-12.1-5.8-4.5-53.4c0,0-12.6,34.9-2.5,54.7Z",
    transform: "translate(0 -0.02)",
    fill: "#eeab89"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 10.48,
    r: 4.1,
    fill: "#eeab89"
  })), _polygon214 || (_polygon214 = /*#__PURE__*/React.createElement("polygon", {
    points: "50.1 285.38 59.3 307.58 49.2 329.28 50.2 333.58 62.9 307.88 51.4 281.58 50.1 285.38",
    fill: "#cf262a"
  })), _polygon215 || (_polygon215 = /*#__PURE__*/React.createElement("polygon", {
    points: "57.3 261.98 76 269.18 83.9 307.08 77.5 265.98 55.6 256.98 57.3 261.98",
    fill: "#cf262a"
  })), _polygon216 || (_polygon216 = /*#__PURE__*/React.createElement("polygon", {
    points: "121.4 261.98 102.7 269.18 94.8 307.08 101.2 265.98 123 256.98 121.4 261.98",
    fill: "#cf262a"
  })), _polygon217 || (_polygon217 = /*#__PURE__*/React.createElement("polygon", {
    points: "129.7 285.88 121 306.88 130.3 328.38 129.4 332.68 117.6 307.18 128.3 281.58 129.7 285.88",
    fill: "#cf262a"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.41,
    cy: 293.44,
    rx: 9.4,
    ry: 14.9,
    transform: "translate(-223.53 169.35) rotate(-56.33)",
    fill: "#a29f9f"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7,226.9c.3,1.8-3.7.1-5.3.1h-.1c-1.7,0-5.6,1.7-5.3-.1,0,0-2.5,4.4.3,7.5a4,4,0,0,0-1,3.6,3.29,3.29,0,0,0,.7,1.6h0c.1.1.2.2.2.3l.3.3.3.2a2.19,2.19,0,0,0,.5.3l.3.1c.2.1.5.2.7.3v.5a1.14,1.14,0,0,0,.3.8.86.86,0,0,0,.3-.6H87a.35.35,0,0,0,.5.5c.1-.1.2-.4,0-.5h.1a.86.86,0,0,0,.3.6,1.14,1.14,0,0,0,.3-.8v-.2h.2l.1.3c.3,0,.6.3.9.3h.1a.63.63,0,0,0,.5-.6v.2a1,1,0,0,0,.7.8,1.47,1.47,0,0,0,.5-.6h.2a1.14,1.14,0,0,0,.3.6.86.86,0,0,0,.3-.6h.1a.71.71,0,0,0,.3.6,1.14,1.14,0,0,0,.3-.8v-.5a6.11,6.11,0,0,0,1.4-.7l.1-.1c.2-.2.4-.3.6-.5l.1-.1.1-.1h0a3.29,3.29,0,0,0,.7-1.6,4,4,0,0,0-1-3.6C97.1,231.3,94.7,226.9,94.7,226.9Z",
    transform: "translate(0 -0.02)",
    fill: "#9a1c1f"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9,227.9c.3,1.5-3.1,0-4.6,0h-.1c-1.4,0-4.9,1.4-4.6,0,0,0-2.1,3.6.2,6.2a3.33,3.33,0,0,0-.9,3,3.1,3.1,0,0,0,.6,1.3h0c.1.1.1.2.2.2l.3.3.3.2c.1.1.3.1.4.2l.2.1c.2.1.4.1.6.2v.4a1.08,1.08,0,0,0,.3.7.76.76,0,0,0,.2-.5h0a.28.28,0,1,0,.4,0h0a1.21,1.21,0,0,0,.1.5,1.48,1.48,0,0,0,.1-.7v-.1h.3s.1-.5.2-.5c.3,0,.6-.4.9-.4h.1c.4,0,.5.9.5.9v.1a.94.94,0,0,0,.5.7,1,1,0,0,0,.4-.5h.1a.55.55,0,0,0,.3.5,2.19,2.19,0,0,0,.3-.5h0a.76.76,0,0,0,.2.5.91.91,0,0,0,.3-.7v-.4a2.73,2.73,0,0,0,1.2-.6H93c.2-.1.3-.3.5-.4v-.1l.1-.1h0a3.1,3.1,0,0,0,.6-1.3,3.57,3.57,0,0,0-.8-3C96.1,231.5,93.9,227.9,93.9,227.9Z",
    transform: "translate(0 -0.02)",
    fill: "#cf262a"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9,228.6h.6c-.1,0-.2-.1-.3-.2a.3.3,0,0,1,0-.4Zm2.2,11.8a.76.76,0,0,0-.1-.4h0v.1A.37.37,0,0,0,87.1,240.4ZM93,228.6c-1-.1-2.4-.6-3.1-.6h-.5C90.5,228.2,92.2,228.8,93,228.6Zm-2.3,11.7c0-.1,0-.1-.1-.2h0c.1,0,.1.1.1.2ZM94,226.9c.1.5-.2.7-.6.7.5,1.2,1.1,3.9-.5,5.9a4,4,0,0,1,.8,3.2,3.51,3.51,0,0,1-.6,1.4h0l-.1.1v.1c-.1.2-.3.3-.5.5h-.1a3.38,3.38,0,0,1-1.2.6v.5a.6.6,0,0,1-.1.4c0,.1.1.2.2.3a2.19,2.19,0,0,0,.3-.5h0a1.42,1.42,0,0,0,.2.6.91.91,0,0,0,.3-.7v-.5a3.38,3.38,0,0,0,1.2-.6h.1c.2-.1.3-.3.5-.5v-.1l.1-.1h0a3.51,3.51,0,0,0,.6-1.4,4.11,4.11,0,0,0-.8-3.2C96,230.8,94,226.9,94,226.9Zm-4.9,11.9h0c-.4,0-.7.5-1,.5,0,0-.1.5-.2.5h-.3v.1a1.7,1.7,0,0,1-.1.7h0l.3-.6h0a.35.35,0,1,0,.5,0h0a2.8,2.8,0,0,1,.1.6,1.7,1.7,0,0,0,.1-.7v-.2h.3s.1-.5.2-.5.2-.1.3-.1-.1-.2-.2-.3Z",
    transform: "translate(0 -0.02)",
    fill: "#e7464e"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7,239.9h0c-.1.2-.1.3-.2.4l.1.1c.1-.1.2-.1.2-.2a.37.37,0,0,0-.1-.3Z",
    transform: "translate(0 -0.02)",
    fill: "#e7464e"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.9,
    cy: 204.58,
    r: 0.9,
    fill: "#fddf00"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 67,
    cy: 203.68,
    r: 0.9,
    fill: "#fddf00"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.1,
    cy: 202.78,
    r: 0.9,
    fill: "#fddf00"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.8,
    cy: 205.48,
    r: 0.9,
    fill: "#fddf00"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.7,
    cy: 206.38,
    r: 0.9,
    fill: "#fddf00"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.6,
    cy: 207.28,
    r: 0.9,
    fill: "#fddf00"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 71.5,
    cy: 208.28,
    r: 0.9,
    fill: "#fddf00"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 209.18,
    r: 0.9,
    fill: "#fddf00"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.3,
    cy: 210.08,
    r: 0.9,
    fill: "#fddf00"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.2,
    cy: 210.98,
    r: 0.9,
    fill: "#fddf00"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.1,
    cy: 211.88,
    r: 0.9,
    fill: "#fddf00"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 77,
    cy: 212.78,
    r: 0.9,
    fill: "#fddf00"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.9,
    cy: 213.68,
    r: 0.9,
    fill: "#fddf00"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 78.8,
    cy: 214.58,
    r: 0.9,
    fill: "#fddf00"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.7,
    cy: 215.58,
    r: 0.9,
    fill: "#fddf00"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.7,
    cy: 216.48,
    r: 0.9,
    fill: "#fddf00"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 81.6,
    cy: 218.28,
    r: 0.9,
    fill: "#fddf00"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 82.5,
    cy: 219.18,
    r: 0.9,
    fill: "#fddf00"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 83.4,
    cy: 220.08,
    r: 0.9,
    fill: "#fddf00"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 84.3,
    cy: 220.98,
    r: 0.9,
    fill: "#fddf00"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.2,
    cy: 221.88,
    r: 0.9,
    fill: "#fddf00"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 86.1,
    cy: 222.78,
    r: 0.9,
    fill: "#fddf00"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 223.78,
    r: 0.9,
    fill: "#fddf00"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 224.68,
    r: 0.9,
    fill: "#fddf00"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.9,
    cy: 225.58,
    r: 0.9,
    fill: "#fddf00"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.8,
    cy: 224.68,
    r: 0.9,
    fill: "#fddf00"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 90.7,
    cy: 223.78,
    r: 0.9,
    fill: "#fddf00"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.6,
    cy: 222.78,
    r: 0.9,
    fill: "#fddf00"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.5,
    cy: 221.88,
    r: 0.9,
    fill: "#fddf00"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 94.3,
    cy: 220.98,
    r: 0.9,
    fill: "#fddf00"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.2,
    cy: 220.08,
    r: 0.9,
    fill: "#fddf00"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 96.2,
    cy: 219.18,
    r: 0.9,
    fill: "#fddf00"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 97.1,
    cy: 218.28,
    r: 0.9,
    fill: "#fddf00"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 216.48,
    r: 0.9,
    fill: "#fddf00"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.9,
    cy: 215.58,
    r: 0.9,
    fill: "#fddf00"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 99.8,
    cy: 214.58,
    r: 0.9,
    fill: "#fddf00"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.7,
    cy: 213.68,
    r: 0.9,
    fill: "#fddf00"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.6,
    cy: 212.78,
    r: 0.9,
    fill: "#fddf00"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 102.5,
    cy: 211.88,
    r: 0.9,
    fill: "#fddf00"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.4,
    cy: 210.98,
    r: 0.9,
    fill: "#fddf00"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.4,
    cy: 210.08,
    r: 0.9,
    fill: "#fddf00"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 105.3,
    cy: 209.18,
    r: 0.9,
    fill: "#fddf00"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.2,
    cy: 208.28,
    r: 0.9,
    fill: "#fddf00"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 107.1,
    cy: 207.28,
    r: 0.9,
    fill: "#fddf00"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 206.38,
    r: 0.9,
    fill: "#fddf00"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 108.9,
    cy: 205.48,
    r: 0.9,
    fill: "#fddf00"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 109.8,
    cy: 204.58,
    r: 0.9,
    fill: "#fddf00"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 110.7,
    cy: 203.68,
    r: 0.9,
    fill: "#fddf00"
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 111.6,
    cy: 202.78,
    r: 0.9,
    fill: "#fddf00"
  })), /*#__PURE__*/React.createElement("image", {
    width: 81,
    height: 77,
    transform: "translate(107.56 167.67) scale(0.93 0.94)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFEAAABNCAYAAADem4jWAAAACXBIWXMAAAuwAAALsAEaOBByAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAFitJREFUeNrsXMty2zgWxYPUw5bidCfunlRlqrzIKlv/gH8i35Pp78lP+Ae89aoXqZpUpWbyclqyJZF4zDkXoEwzsmw5ctI1ZaUQUDQJAofnPnBxIR1jVA+f7/uYBwgeQHwA8QHEh8/yU/ydOqPxYX2TqdO5jn8Tq6h/Zj8I2jafrn8SsOZnINeUVaP9I2GxtvyRS/fe2Gq/YfX/DRP1GsBerzj/ZgVA7c+rayQe7anXq/52z4O8VxBXgdcFjoC96lxzTBCPjq5t9+j4OK4A/gq4KwG9p8HeC4hd8NYBR8AErgzayWSyZOFhp92T1vHheHz5iONjtqOOMmhvvmXrvYK5fRBbuqgN3jfAtUAjWKfzudz3EuXPxWKtOL/o96XTp/n7y8EgnjTAHh93QYurmLlNI7Q1EFeIrr4OvDZwDWgvUL99/lwfoH53A4jPAeJbOXqrDt4V8c8M7GkH0GMASna2mfmNmG8BgO2AeA37GiCXzAN4beAK5/TBwYGAZqtKrjV1vWzLeP8NmMHaZYdDWcZnvV58h2P3/n08KC4BVTeAqbbIyu8HcQWADfvazBtm8BQAewvwimfPBDiC9jtOfwBg+vFjfYa//Zrb4/EvrUd9QXkMoARA1h8/qoiawP4OQBUB/fe/lcM5litgnpxE9S2AWwHy+0BcB+DRkR63wGuY1wbPZOAMzmsWfP9rNNINAx+hTFpsHAOsv3L99etX9Qh1ZCGQKPHsTAAlQ/1//hMbMCuASTFXSWduHcg7g9jWgesA7HXA+zKfm99awE2qyhgARwAF1BC0Hg4FOL1CnAU0O4tqimNjBLRRrxfidCqAfgJoe9NpaIP5fDAIqsXKCcDMbtJWgLwTiOsAhKuiT1oAvoCxeD+ZGDLvbLww++6x/muxML8AuCkAfASgLvq10X6YAETBYKWe87j1GQC0mdTzqOYmEkQBsqoC612AeQYwx6g9gGuYWe/uBurMhpUzgLkOSPUjQGzEeB2ALwHgu/19Q/YVYN/X0cg8AfPMsDLTamhsXRvT6xkBrufMwvXMMIOo+32tUC9YYpRn9fN7I1gDg7MLAIrjflGEmEEMC9xRloFghtksfAaAjwCmn0yCGKHxOPz57t3WgdwYxI4ro1fqwAzgcwD4AQBaAGjAPjMcGg32zYrCQpyNJoioF6UzxpVgo8c5gBZKPCQKkHUGkR+eVWQf67qm+IYeSqzrAL0YhJGsM5g7w6EnmI2IOwB6ayA3AGbjAETsuC/XAVien5sGwOnFhT3v9ayZz+3cmKIy88KgBgylAzbex54PoefL2LOhhCz6vkcJNvRtUfQgkrkO6Tz/Xpa4NvQcS8R9aKtGW5btW1vgejs7Py8snvsUL5D9oERQtVDFUNWwv+PLGZJuBUCuGM2tgqhbYtycohvTNiINgGfo+GQwsBYAlhhIUSQAOUirTUHwOHCCVwA4KwAWPW983xI0lmAJ2ABgSR343eYCIOeoE/hlr2Y7A13yxRTNcwDkBV6cvMBrgDzMaqiZGLy+dxfn8u3oth48/fDBsEODlg4kgE8guhcYAAdjqsoa1kCn1lWha2Nhn8lICzG2EGgLFGGgDWgUtQ/GQKS0a4mzohijAFTqwBC9DxBpDwH2oQgefo6Ho+MAsO/1+1IH57yvaw9R9rtV5UMf+GfRXnz6FA5gdGi11aUfubFYm7uysHGmaUjoB9KNaQCUN94BsKb4AjQR4dgrKboBYggNl8TVgG1OD4L2g9opKM8wsFoPwKjLwu8hDKATB5EMNaYvLKXYg8UmM9v3lDCy4kvC821Z2iIzkp6B+KbwFuh20flXkKKTw0ORKnVDGO77mHgLFlKMJ8Oh6CB2mB3Hp6izeBFEy4EBcw9xhlUptNLgkC5gNKzXnscWxsOgY0ZZq9UVJnqwEAyEDYcuDNZEj4scRNlbzPzwUpwtVR1UKceF1rVH3UOZgJH9AF5mRvpstevPn8Mcxy/29oIag43Hm7PRbMLCVlA0xfw6LKQeTG7M0OzBhSEDqqUI62JIAMmWmFkYbC8G0wdm/aATw3A8IAsNjpXyQzQ/BEBS45FDjAbFD8nKGBpGxj6eAdpbtFuIkcH9BVRByZdGRhZkJMoenXv0j84+nXv7++8yGRA2Tu7GRrOJRW6H5DknlvAVZyQQC85E9iEmnIGcZzdm0QLQ5kGRgTYZFRAk9iPEGKD1EyAo8KUbsEwusVMUAcyFLwCkBckg1vJiQk9no2Uy6+Hpox8V+lPZWVIv4nItxRog/pmNTDsW3Iz3pqWGjVb7Gsd6P1tkPpTBhD5Y+Btq6puSb7mYGz2DACslxsP2MBAaTRxDNEoONhhYY4p0MD1aash1kV1Bq6O2AfdGj5dsOGtBpQIPQ6BwQXFGHeBURhdF5lUNU2QMZ40cOK4CuKrPa+lpVjRIRVS0R5B6tGKmw2Hcnc8jmByFjZ8+JTaqQ/w7idlSx9usPm68ZPqqiUJPJhJUGICF5vxcG7zVXy4u9AxiPPelBWQW4FhYSzjWCpbZFT4WBDAxEcWBQQUZY5QAaegzok8AxQIgA31pAuYoigACXR8xHg0FAMR8ULDjpo6000DZ0VzLRZiDowrUY7DtocZbgdUCEEHDMcdchy8oQP1IK8JGEGLJRlrqpPO352yv8A3lQ1FudKEEDnA85YxkCD2DaZzGLGRYgB0QZ9FPjqLlKF6ltrGECIpljtBnoEsfwPTBQICKGiKNgQ49xTdqTKT1AKANqSdxHcQ4DiCj8GEURkxdCp2YLX1RKGE6RVrjmZrPFpF2gLyWmZLMljAbmrZ04/N//lO9aCLsK9Z31om0ua0+bES57daogwP1ATpFP3bLKIyp+2YnDDSncbQtOECBD0h/UKdBAaA0UKMETE0wAQSLB0AawFqCiWMwcqAAHGsBDABHgOcVjU8E4Lxfsy3qWMxeYFzYPkpFZvOZxtva4fkFNEpZynRT5u0MvVE3Asj3IANV08vOOk9DnrjVDAi8pMNJig8OUBhQNe6x1qMLrc/ldTFwYCCu6DBE0heA0cMlNgUMB0ahCshWiVdLJYWBqx5epQCBjpJB6JMuvA4FzoF4HAT1Ir5Rq0FS8RBnOInGeZyEG6TFCwlyDf+uKe0etwJD7zQF32jrnINYGL9A30pFXRFS7PLpU0WRZpQd82pGkSLJ8uG6JdjvAfFVg6KaqHYInxHop2akNXwYqGqgFcXP47TDC4DEEG4dsCUzMHZILXWgTsYEJQNYJnbGksYFTIROBFoiMIBe4FIe/1uoASNwAVkih0sjlCmUHDxNdAFAQywMAAx4PEBkcINMhHiwb/MM5N7ensKMRvvLtZ142Azz+Ha43CkXp1kneZ/XRX7JEegyKQ6JwNRkIzqL8dLCAlCAAiCp3qHbIK0oKop4oyaQRQKQgEYCzMUUWmqBSZgo9oLtKKcv1Q3O02on8ALZx7aCceKDQydj+mdFNUMXwm8VWi4/WZ+LXuyK3C1RNHcxKiq7NnKNc1ej0iwSrMK8lx0HmBgQpiwEFxYU4IEtUsg2RUsclOhL6DoBNIk6RF4pqUXEdVwew48pIK9kL0mAqbNi87S6hTCYsx08VGY+eD7n4lAEMhdf9pEFfW4vPzSkaJZv7z8X5yDXT6+eHsgqUkjTtQwmaw8APRkpos7Babp9GF4UVoJJwCFaiipAkmMAm87xGgIa0/fYPo9zlmIvDI1GVIAmkGnqKOeCHPPVLF9wAyTXcb4CyM+ZFA05tgZi2zK3lKIssHc/I7IyR6OFoWWpe6Iwooh4AhV+McajjAALZmCM6W+G4VYASB+ZpoSRV5PO07hoqZWOy5on5XqcCHJNNKlNIqzSM8hAZZcvlNqDfVq0lh2mAPAx6idrcLhp5mI2dbUb808iPrvmqioHDVJUumxHO+S8p4mQkSoCoFMvZGJCK6up5gglcJWaLjb/4UIKafpOKHm/SsdpIDY1JO65El2x/ORuVCV8p0Zirvm8XDFTW+fmbAjim2UODDMQ3l9zVS+vIEg4X9WXzM7nyQ3YWDEKlDOOWL6FS7hVzCdiE0lRvJDmWkIqIcGe1qCX93l5D/wja39HTXW6TXHWrQyrZerVNQ+Z5kWkPt03AayOFQ8cUVIpmKrF0xP3rgmwqvQ3+n5082h9gziAPCbR5HYt341osSj+IqRV/sZzLPRzBPwU3EvPELJ6eU6d32WvTus081bfz24bg7kmJHZ3w/I21x+vnpbOEcg6gRSXYHlMa70Mmmodl2DSEQiaJ3j0OAkWmOnpUAMUmE245wxu4xy/Ywz8jkbQWD6HBkJkO+l7UAncQEVx5WVJcdKfNBXKy63Wxr2cAHBXKNb6ibKIDWWavfaVSpUP55ss2RGdWCcfHBfWQ9IsZTBg+JfBVE2PmPY5OrTMgANGR6uL74k+WsxMSM6K8Ivf2ZBhAILRGzrT2gEox3ZCBtkbvgATPCE0dB/pQIVQwFm1PgafwYtJKq6MhXk9imCmIMR2QFz34UJ4gYcW87kkGTG1Y0YQ86ckUI4YenovgS4vuCKeDgcNvsCXMJzJEAibzIoS80ebQd+PMRnOzBim4XiTTy0vAyAK4DVGyxrTQLwIOOEAkArEwTrT+caEjysx8ICMDwu8FKeryBBRmR2vGHfjF+/VmDOWLEkvtsnEb82KUvvw4o8Gh7HJISSATDKKdhrjeUExgcOH94/iysgVJEy8QDyPAWHgjoOO9AcZ2AN4HoJvZOKmZRpsxDCEPM8Tvy95LoHKM8hEGvfCUDtwjilklU5g8rgOGVSbwQR1ZSHL05W0LvRqdMalJQByduym0e/sxLqVbZbyRo/Vh0uvbsvO9nHKWGXGlcvJlqE4i3Fql2kdXEBXjN05dpwLcVZErYaUBRFFjEYG7WtAV0UJqgbWFQZWAdIKZMRbkgSIheYxa8Y2cByX30OFv8k9DZCGtY1s39VgIZ9bcWUQQEbpjw2SNdH0lTk7TDcpSxkPx3WybSbqbJquJEeOxzI12nn7VoUnT6I5Q18HNmVkFfPAUXKiXErYs/RRljQBHqaw9LBhF+Akc9Ii5lRlG02tyGkLRZiibMXZFiZmOQdHIfdijCjOkTrR8wVogA5AA16ITkCykImeE2iDeTTAK7l06qmnFbkZdnd3g6+qS6OC8Zzu7jZunJQ87iUOdwLxOuPCVDWItOhFw5QOdGRUXoTZeQG5xfwOZUaSMtTcgwoNOK+TSo/M5ZRQVI7TEEFtiSEkLZQMFYSQojjyTDrkVLeicpNlx2vzBf0oQ0c01glAnZjtNcQabOSyTuEcV6IZlfVFQWZKlHsH/fsyncYRRJkv32Mc1POSgtcKPCyXCNas+N1uybSzXCprLIeH+hBsfHt+bvpPnphyMLXT86FkO1T6oii5Bq8Neq1LG3sp2yHmdZW8xhIY3c6hsBwOKyWIQBbSppo0NbR54V6c7Si+YmajRHOSCJN5SSVAa+gK76cCjSuqDWtc5StVg4MOE5carpYsndZV5RezmX80GvlmIf+E+TknJxH6ML5qL+avAWojw7JKpF/i7b3DW/xyVsR/jPphWl7op7O+nzMKijLhUhyduzQNk+lZSCyUnoGAIl50OMAkT0vNLETNfzFZbFoq+szyyrliFTkZgR9JNlpVw044ARIMFFGmeNPI0LDAkmsat1J8SqoW2Boo59ksPNrZCTW+1ug/U5VPlVopyltZvO9mgjU5OEdgo2qx8S+w8bf5yDCJSJKJSuYXpbwbWb7My6Ymh+81V/5kdpgX9BnNpsUmkCZK4JnxHHU5qxP/WNwcAgKxphWmEbEZNIq0SVa65uL9jIv4ZB8X8cHEAUoAC6EL/X+n09BmoUS0wcKjSwbG2yR+3m7dudPAG5X3jOCtnWafkTrl8aQvaWxMZ6O4TIpFkFwYdpysyFkJNouasXYBUuCiAGsb51CB88BaqRkU4SzV3ZLOQ9Tlet7H+4P2qT20y/b5HD6vbHJzck7O17IMTbrdY+blZF14mqQrNgny68Z/91yclkg3y4n0pZjjJ+7O+/fiJkiqLzuHjg5c34dez6PbrgHSkyVM7zAGegu6KhgAaRbwhxemBSR8Efq9GbRU+J3nQ76O18t9uJ/tSHvSLtrPzBQ9yGejH8xZZL/YP+kn3Rr0+0XOVTxOe2BkfH90xr0VZ7trpZfbGbJu7OUZjKi86VSBiXqvqtSFzPp7qsQxYwAmJ2rSHaTfJgEEA02PuUXJSLj3XB1kbN/oQl3NxaHTA30ASxs479bW4j54ABZTDviiMO2wxngvmmmLwZecydC9AoAwJX4HIvyJqcg5K6zNwkYX5nHdyirfLT9xDRuZeTr/8EE6JnnS6Cg7zI5zAJgqcBbooABrFkdrKYx0FXyixEbvFxBJEVFdkG3h2yLn45zXyfW4j/cDz4XP7TbPCMLA+gqAdU6KZz/Z3+o7WbixdV7hM0ZZzhmPl9e8QMfe7e8rRovPwMhPo5EqwMKR3YEpmHMybGgdCiVxaW9qbenEYaBpXdg5LldpxvtlHavFRAYNOG2GNYkirEw1dnQH4UlVwKZEe9DA9CHJxFDXYcfu+C/VLDQAUg8yEf45+nnaTjluGZJNWHinaZ/uxNjEyBwfS0fYIXaMHWRH2eHxfO7h0Io1pLHx2dDQXyuz7iKDYMYrW9diHDAZxMUwEGCXs2RnqoVtOM+/8zpez/t8bkcYqJI/yOe4bIX5fPbjWgDR/zedcW2y0LJ5znbr7TRi3QB5uAJI0T1gwEcOAAMa7u66YSR/krFpwHTJJalKWwkwAo4jsAk0qZ1Z/o3X8XrXAY/tsn0+h8/72MqM7QJ42AKwLcabsPCH7GNpUpCZwmbH45T7slgwK8vsYUZ4XtdmNBxKIlTaw8JVuIHsYdF5QWnQBHuXWzAYPLjcyzKE1Z3OZnEX9VduDsoWmLusmu0XXR2Yd6ReAfD1Lf3CrUS2Y7xUVK9zBxpGqpZoN8aGzixZ8BQiJazY3YWUVSJqw10nro/LLPLRcyVbmFWRZWRYrpvvTjJg/fKeIMyD/KI9tsv2+Rw+j8/l89sATrYI4N03A307p75xb5/kRnNNl3nSeX8LE6Ekj2e5r49JACPd3tPX3mna7DBt9vgFO42Ppu39fWcxYvq5z21odLfgA0qkOm/j7erALoCb7l/ZDog3Ablii24bzPdXNko6fQZAucO0vbv0awvEvQxis9v0s9QJuGYv37MV4DWbI7tbdre19/mn7Xdub9l9nlM4mr3OnwDcfqt5Zif82lpIYsT5SQZ01Z7n68BrW99tbh7/oTvvVfMDGZ3N42nXPaNaB6ro7LpvNpNL/CHNiC7XeSSyvnr3ver8lMF9bRjfKog3sXLdzxi0M826v/9QtHJjXGdZ8wpoKi1bHHaYd98/XXA/IKrb/xrJ8S1+iaSdodUGa3ld86skrV8kuennXbb9S04/9XdxbvObOEdX/9ZejmvrOXUj69T9/QzWT/uFptv+OtOrDkidv8W10fd7Bu+KWvhRpcluuK78C25h3KDk669tryHJfZef9qt12/7Fuh/Gup8lzrcFVakNduCov8/vKOqHXzf+/s/Dz6E+gPgA4gOID58HEB9A/Lt9/ifAAK6P+O52Hk59AAAAAElFTkSuQmCC",
    style: {
      isolation: "isolate"
    }
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M133.1,202.6c0,5.7,6.7,10.7,12.3,10.7s12.3-4.6,12.3-10.3-6.7-10.7-12.3-10.7S133.1,196.9,133.1,202.6Z",
    transform: "translate(0 -0.02)",
    fill: "#c0272d"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M149.1,206.9a.56.56,0,0,0,0,.9.75.75,0,0,1,0-.9Z",
    transform: "translate(0 -0.02)",
    fill: "none"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M149.1,206.9a.56.56,0,0,0,0,.9.75.75,0,0,1,0-.9Z",
    transform: "translate(0 -0.02)",
    fill: "none"
  })), _polygon218 || (_polygon218 = /*#__PURE__*/React.createElement("polygon", {
    points: "150 208.28 150 208.28 149.8 208.28 150 208.28",
    fill: "none"
  })), _polygon219 || (_polygon219 = /*#__PURE__*/React.createElement("polygon", {
    points: "150 208.28 150 208.28 149.8 208.28 150 208.28",
    fill: "none"
  })), _polygon220 || (_polygon220 = /*#__PURE__*/React.createElement("polygon", {
    points: "150 206.38 150 206.38 149.8 206.38 150 206.38",
    fill: "none"
  })), _polygon221 || (_polygon221 = /*#__PURE__*/React.createElement("polygon", {
    points: "150 206.38 150 206.38 149.8 206.38 150 206.38",
    fill: "none"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M141.6,192.8a13.69,13.69,0,0,0-9.5,13.1h26.4a13.6,13.6,0,0,0-9.5-13.1,11.8,11.8,0,0,0-3.7-.5A9.26,9.26,0,0,0,141.6,192.8Zm5.5,2.9a2.79,2.79,0,0,1,2-.8,6.82,6.82,0,0,1,4.6,2.3c2.2,2.3,2.9,5.3,1.5,6.8a2.79,2.79,0,0,1-2,.8,6.82,6.82,0,0,1-4.6-2.3c-2.2-2.2-2.9-5.3-1.5-6.8Z",
    transform: "translate(0 -0.02)",
    fill: "#c0272d"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M147.5,195.8a3.23,3.23,0,0,1,2.1-.8,7.08,7.08,0,0,1,4.8,2.3c2.3,2.3,3,5.4,1.6,6.9a3.23,3.23,0,0,1-2.1.8,7.08,7.08,0,0,1-4.8-2.3C146.7,200.4,146,197.3,147.5,195.8Z",
    transform: "translate(0 -0.02)",
    fill: "#c0272d"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M153.9,205.1a2.78,2.78,0,0,0,2.1-.8c1.5-1.5.8-4.5-1.6-6.9a7.06,7.06,0,0,0-4.8-2.3,2.78,2.78,0,0,0-2.1.8c-1.5,1.5-.8,4.5,1.6,6.9A7.78,7.78,0,0,0,153.9,205.1Z",
    transform: "translate(0 -0.02)",
    fill: "#c63d42"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M153.9,205.1a2.78,2.78,0,0,0,2.1-.8c1.5-1.5.8-4.5-1.6-6.9a7.06,7.06,0,0,0-4.8-2.3,2.78,2.78,0,0,0-2.1.8c-1.5,1.5-.8,4.5,1.6,6.9A7.78,7.78,0,0,0,153.9,205.1Z",
    transform: "translate(0 -0.02)",
    fill: "#c63d42"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 142.2,
    y: 249.68,
    width: 1.8,
    height: 178.6,
    fill: "#c0272d"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 142.2,
    y: 249.68,
    width: 1.8,
    height: 178.6,
    fill: "#1a1c1d"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 146.7,
    y: 249.68,
    width: 1.8,
    height: 178.6,
    fill: "#c0272d"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 146.7,
    y: 249.68,
    width: 1.8,
    height: 178.6,
    fill: "#1a1c1d"
  })), _polygon222 || (_polygon222 = /*#__PURE__*/React.createElement("polygon", {
    points: "144 452.08 144 428.38 142.2 428.38 142.2 452.08 144 452.08",
    fill: "#faaf3a"
  })), _polygon223 || (_polygon223 = /*#__PURE__*/React.createElement("polygon", {
    points: "144 452.08 144 428.38 142.2 428.38 142.2 452.08 144 452.08",
    fill: "#faaf3a"
  })), _polygon224 || (_polygon224 = /*#__PURE__*/React.createElement("polygon", {
    points: "146.7 452.08 146.8 452.08 148.6 452.08 148.6 428.38 146.7 428.38 146.7 452.08",
    fill: "#faaf3a"
  })), _polygon225 || (_polygon225 = /*#__PURE__*/React.createElement("polygon", {
    points: "146.7 452.08 146.8 452.08 148.6 452.08 148.6 428.38 146.7 428.38 146.7 452.08",
    fill: "#faaf3a"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 146.7,
    y: 220.58,
    width: 1.8,
    height: 29.2,
    fill: "#faaf3a"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 146.7,
    y: 220.58,
    width: 1.8,
    height: 29.2,
    fill: "#faaf3a"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 142.2,
    y: 220.58,
    width: 1.8,
    height: 29.2,
    fill: "#faaf3a"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 142.2,
    y: 220.58,
    width: 1.8,
    height: 29.2,
    fill: "#faaf3a"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 249.68,
    width: 3.6,
    height: 178.6,
    fill: "#c63d42"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 249.68,
    width: 3.6,
    height: 178.6,
    fill: "#373d40"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 428.38,
    width: 3.6,
    height: 23.7,
    fill: "#fab64f"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 428.38,
    width: 3.6,
    height: 23.7,
    fill: "#fab64f"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 220.58,
    width: 3.6,
    height: 29.2,
    fill: "#fab64f"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 220.58,
    width: 3.6,
    height: 29.2,
    fill: "#fab64f"
  })), _polygon226 || (_polygon226 = /*#__PURE__*/React.createElement("polygon", {
    points: "144 217.48 144 217.48 141.1 208.68 132.2 208.68 132.2 208.68 140.8 217.48 141.6 217.48 141.6 220.58 142.3 220.58 142.3 220.58 144 220.58 144 217.48",
    fill: "#f69220"
  })), _polygon227 || (_polygon227 = /*#__PURE__*/React.createElement("polygon", {
    points: "144 217.48 144 217.48 141.1 208.68 132.2 208.68 132.2 208.68 140.8 217.48 141.6 217.48 141.6 220.58 142.3 220.58 142.3 220.58 144 220.58 144 217.48",
    fill: "#f69220"
  })), _polygon228 || (_polygon228 = /*#__PURE__*/React.createElement("polygon", {
    points: "146.7 217.48 146.8 217.48 146.8 220.58 148.4 220.58 148.4 220.58 149.2 220.58 149.2 217.48 149.9 217.48 158.6 208.68 158.5 208.68 149.6 208.68 146.7 217.48",
    fill: "#f69220"
  })), _polygon229 || (_polygon229 = /*#__PURE__*/React.createElement("polygon", {
    points: "146.7 217.48 146.8 217.48 146.8 220.58 148.4 220.58 148.4 220.58 149.2 220.58 149.2 217.48 149.9 217.48 158.6 208.68 158.5 208.68 149.6 208.68 146.7 217.48",
    fill: "#f69220"
  })), _polygon230 || (_polygon230 = /*#__PURE__*/React.createElement("polygon", {
    points: "147.5 217.48 147.5 217.48 150.4 208.68 150.4 208.68 141.3 208.68 141.3 208.68 144.2 217.48 144.2 217.48 144.2 220.58 147.5 220.58 147.5 217.48",
    fill: "#f89e36"
  })), _polygon231 || (_polygon231 = /*#__PURE__*/React.createElement("polygon", {
    points: "147.5 217.48 147.5 217.48 150.4 208.68 150.4 208.68 141.3 208.68 141.3 208.68 144.2 217.48 144.2 217.48 144.2 220.58 147.5 220.58 147.5 217.48",
    fill: "#f89e36"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M149.2,453.9h-6.9a.78.78,0,0,0-.4.4,4.9,4.9,0,0,0,0,7.2,5.69,5.69,0,0,0,7.7,0,4.9,4.9,0,0,0,0-7.2c0-.2-.2-.3-.4-.4Zm0,7.3a4.47,4.47,0,0,1-2.7,1.2,2.17,2.17,0,0,1-1.4-.5c-1-.9-.6-2.6.7-3.9a4.47,4.47,0,0,1,2.7-1.2,2.17,2.17,0,0,1,1.4.5c1,.8.7,2.6-.7,3.9Z",
    transform: "translate(0 -0.02)",
    fill: "#faaf3a"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M145.2,457.8c-1.2,1.2-1.5,2.9-.7,3.8a2.11,2.11,0,0,0,1.3.5,3.7,3.7,0,0,0,2.5-1.2c1.2-1.2,1.5-2.9.7-3.8a2.11,2.11,0,0,0-1.3-.5A3.72,3.72,0,0,0,145.2,457.8Z",
    transform: "translate(0 -0.02)",
    fill: "#fab64f"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M141.3,208.7v-.6h0a1.22,1.22,0,0,1-1.2-1.2,1.16,1.16,0,0,1,1.2-1.2h0v-.6h-9.1v3.6Zm-4.6-3v0Z",
    transform: "translate(0 -0.02)",
    fill: "#faaf3a"
  })), _polygon232 || (_polygon232 = /*#__PURE__*/React.createElement("polygon", {
    points: "141.3 205.08 134.1 205.08 132.2 205.08 132.2 208.68 141.3 208.68 141.3 208.68 141.3 208.08 141.3 205.68 141.3 205.08",
    fill: "#faaf3a"
  })), _polygon233 || (_polygon233 = /*#__PURE__*/React.createElement("polygon", {
    points: "156.6 205.08 149.5 205.08 149.5 205.08 149.5 205.68 149.5 208.08 149.5 208.68 149.5 208.68 158.6 208.68 158.6 205.08 156.6 205.08",
    fill: "#faaf3a"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M141.3,205.1v3.6h9.1v-3.6Zm4.5,3a1.22,1.22,0,0,1-1.2-1.2,1.16,1.16,0,0,1,1.2-1.2,1.22,1.22,0,0,1,1.2,1.2,1.4,1.4,0,0,1-.3.9,1.22,1.22,0,0,1-.9.3Z",
    transform: "translate(0 -0.02)",
    fill: "#fab64f"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M145.4,208.7a1.4,1.4,0,1,1,1.4-1.4A1.5,1.5,0,0,1,145.4,208.7Z",
    transform: "translate(0 -0.02)",
    fill: "#fab64f"
  })), _polygon234 || (_polygon234 = /*#__PURE__*/React.createElement("polygon", {
    points: "149.5 453.88 149.5 452.08 149.2 452.08 149.1 452.08 147.5 452.08 147.5 452.08 144.2 452.08 144.2 452.08 142.6 452.08 142.6 452.08 142.2 452.08 142.2 453.88 142.5 453.88 149.3 453.88 149.5 453.88",
    fill: "#f69220"
  })), _polygon235 || (_polygon235 = /*#__PURE__*/React.createElement("polygon", {
    points: "149.5 453.88 149.5 452.08 149.2 452.08 149.1 452.08 147.5 452.08 147.5 452.08 144.2 452.08 144.2 452.08 142.6 452.08 142.6 452.08 142.2 452.08 142.2 453.88 142.5 453.88 149.3 453.88 149.5 453.88",
    fill: "#f69220"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 144.9,
    cy: 262.61,
    rx: 14.9,
    ry: 9.4,
    transform: "matrix(0.99, -0.14, 0.14, 0.99, -36.31, 23.58)",
    fill: "#a29f9f"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDigmenthaColored, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/digmentha-colored.e8076c38.svg";
export { ForwardRef as ReactComponent };